import { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getListOrders, saveEditOrder, sendToPrinter, cancelToPrinter, saveEditOrderMember, syncMatchDesign, combinePackage, makeOrderComplete } from "actions/orderActions";
import { getShops } from "actions/shopActions";
import { getStaffs } from "actions/teamActions";
import { formatterCreateAt, subStringText, FormatterStatus, formatterImage, convertTZ, getRange2TZ, getTimezoneOffset, findHexAndNearestHex, FormatterMoney } from "components/Function";
import { ReactTable, ReactTableDataGrid } from "components/Table";
// import { textFilter } from 'react-bootstrap-table2-filter';
// import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import ReactImageMagnify from 'react-image-magnify';
import { Modaleditdesign, Modaleditorderstatus, Modalbuylabel, ModalChat, Modalimporttracking, Modalproductsettings, Modalsplitorder, ModalRefund, Modalimporttrackingv2, Modalcustomer, Modalexportorders, Modaluploadinvoice } from "./modal";
import DateRangePicker from "react-bootstrap-daterangepicker";
import cx from "classnames";
import SelectCustom from "components/elements/selectCustom";
import { listManufacturer, listType, listSize, listColor } from "helper/constant";
import moment from "moment";

function Listorders(props) {
    const [isOpenModalEditDesign, setIsOpenModalEditDesign] = useState(false);
    const [isOpenModalEditOrderStatus, setIsOpenModalEditOrderStatus] = useState(false);
    const [isOpenModalBuyLabel, setIsOpenModalBuyLabel] = useState(false);
    const [isOpenModalSplitOrder, setIsOpenModalSplitOrder] = useState(false);
    const [isOpenModalImportTracking, setIsOpenModalImportTracking] = useState(false);
    const [isOpenModalProductSettings, setIsOpenModalProductSettings] = useState(false);
    const [isOpenModalImportTrackingV2, setIsOpenModalImportTrackingV2] = useState(false);
    const [isOpenModalCustomer, setIsOpenModalCustomer] = useState(false);
    const [isOpenModalExportOrders, setIsOpenModalExportOrders] = useState(false);
    const [isOpenModalUploadInvoice, setIsOpenModalUploadInvoice] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [editdesign, setEditDesign] = useState([]);
    const [productsettings, setProductSettings] = useState([]);
    const [editorderstatus, setEditOrderStatus] = useState([]);
    const [importtrackingv2, setImportTrackingV2] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [exportorders, setExportOrders] = useState([]);
    const [uploadinvoice, setUploadInvoice] = useState([]);
    const [buylabel, setBuyLabel] = useState([]);
    const [splitorder, setSplitOrder] = useState([]);
    const [printer_tmp, setPrinterTmp] = useState({});
    const [orders_selected, setOrdersSelected] = useState([]);
    const [editMember, setEditMember] = useState(null);
    const [date_type, setDateType] = useState("");
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [filter_printer, setFilterPrinter] = useState([]);
    const [filter_shop_code, setFilterShopCode] = useState([]);
    const [filter_status, setFilterStatus] = useState([]);
    const [filter_work_status, setFilterWorkStatus] = useState([]);
    const [filter_staff_note, setFilterStaffNote] = useState([]);
    const [filter_order_design, setFilterOrderDesign] = useState("");
    const [filter_shipping_type, setFilterShippingType] = useState("");
    const [filter_staff, setFilterStaff] = useState([]);
    const [orderRefund, setOrderRefund] = useState("");
    const [openIndex, setOpenIndex] = useState(null);
    const [tab, setTab] = useState("orders_all");
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tab_order = searchParams.get("tab");
    const navigate = useNavigate();
    const [scrollTop, setScrollTop] = useState(0);
    const { t } = useTranslation();
    var { listorders, totalsize, isLoading } = props.order;
    var { list } = props.shop;
    var { list: list_team } = props.team;
    var { role, teamRole } = props.user.user;
    var { getListOrders, subStringText, formatterCreateAt, saveEditOrder, sendToPrinter, cancelToPrinter, FormatterStatus, formatterImage, saveEditOrderMember, getShops, getStaffs, syncMatchDesign, combinePackage, makeOrderComplete } = props;
    const list_shop = list?.map((v, i) => {
        return { label: `${v?.name} (${v?.note}) - ${v?.region} - ${v?.code}`, value: v?._id };
    });
    const list_staff = list_team?.map((v, i) => {
        return { label: v?.user?.email + " - " + v?.user?.name, value: v?.user?._id };
    });
    const list_date_type = [
        { "label": "Alltime", "value": "" },
        { "label": "Today", "value": "today" },
        { "label": "Yesterday", "value": "yesterday" },
        { "label": "Last week", "value": "last_week" },
        { "label": "Last month", "value": "last_month" },
        { "label": "Last year", "value": "last_year" },
        { "label": "This week", "value": "this_week" },
        { "label": "This month", "value": "this_month" },
        { "label": "This year", "value": "this_year" },
        { "label": "Custom", "value": "custom" }
    ];

    const list_status = [
        { "label": `UNPAID`, "value": `UNPAID` },
        { "label": `ON_HOLD`, "value": `ON_HOLD` },
        { "label": `PARTIALLY_SHIPPING`, "value": `PARTIALLY_SHIPPING` },
        { "label": `AWAITING_SHIPMENT`, "value": `AWAITING_SHIPMENT` },
        { "label": `AWAITING_COLLECTION`, "value": `AWAITING_COLLECTION` },
        { "label": `IN_TRANSIT`, "value": `IN_TRANSIT` },
        { "label": `DELIVERED`, "value": `DELIVERED` },
        { "label": `COMPLETED`, "value": `COMPLETED` },
        { "label": `CANCELLED`, "value": `CANCELLED` },
    ];
    const list_work_status = [
        { "label": `new`, "value": `new` },
        { "label": `processing`, "value": `processing` },
        { "label": `working`, "value": `working` },
        { "label": `worked`, "value": `worked` },
        { "label": `overdue`, "value": `overdue` },
        { "label": `ship_late`, "value": `ship_late` },
        { "label": `cancel`, "value": `cancel` },
        { "label": `warehouse_out`, "value": `warehouse_out` },
        { "label": `produced`, "value": `produced` },
        { "label": `scan`, "value": `scan` },
    ];
    const list_staff_note = [
        { "label": `staff_note`, "value": `staff_note` },
        { "label": `media`, "value": `media` },
        { "label": `done`, "value": `done` },
        { "label": `printed`, "value": `printed` },
        { "label": `stamped`, "value": `stamped` },
    ];
    const list_order_design = [
        { "label": `Order with design`, "value": `with_design` },
        { "label": `Order without design`, "value": `without_design` },
    ];
    const list_shipping_type = [
        { "label": `Ship by TIKTOK`, "value": `tiktok` },
        { "label": `Ship by SELLER`, "value": `seller` },
    ];
    const list_printer = [
        { "label": `Cotik Partner`, "value": `cotik` },
        { "label": `Flashship`, "value": `flashship` },
        { "label": `Mangoteeprints`, "value": `mangoteeprints` },
        { "label": `Gearment`, "value": `gearment` },
        { "label": `HM Fulfill`, "value": `hmfulfill` },
        { "label": `Lenful`, "value": `lenful` },
        { "label": `OnosPOD`, "value": `onospod` },
        { "label": `A2K Ecom`, "value": `a2kecom` },
        { "label": `Printeeshub`, "value": `printeeshub` },
        { "label": `Monkeykingprint`, "value": `monkeykingprint` },
        { "label": `KV Fulfill`, "value": `kvfulfill` },
        { "label": `VisiovSolutions`, "value": `visiovsolutions` },
        { "label": `Saigongroups.us`, "value": `saigongroups` },
        { "label": `Burgerprints`, "value": `burgerprints` },
        { "label": `Printiz`, "value": `printiz` },
        { "label": `Printify`, "value": `printify` },
        { "label": `Oneprint`, "value": `oneprint` },
        { "label": `OP Creative`, "value": `opcreative` },
        { "label": `Menprint`, "value": `menprint` },
        { "label": `Teroprints`, "value": `teroprints` },
        { "label": `Fprint`, "value": `fprint` },
        { "label": `Printsel`, "value": `printsel` },
        { "label": `Tebprint`, "value": `tebprint` },
        { "label": `Merchize`, "value": `merchize` },
        { "label": `Saigongroups.net`, "value": `saigongroupsnet` },
        { "label": `Pressify`, "value": `pressify` },
        { "label": `THG Fulfill`, "value": `thgfulfill` },
        { "label": `Smartfactore`, "value": `smartfactore` },
        { "label": `Viettelpost 1`, "value": `viettelpost_1` },
        { "label": `Viettelpost 2`, "value": `viettelpost_2` },
        { "label": `Lizyprintfull`, "value": `lizyprintfull` },
        { "label": `Sellerwix`, "value": `sellerwix` },
        { "label": `Anprints`, "value": `anprints` },
        { "label": `Hogotopod`, "value": `hogotopod` },
        { "label": `Dreamship`, "value": `dreamship` },
        { "label": `Printdoors`, "value": `printdoors` },
        { "label": `Merchfox`, "value": `merchfox` },
        { "label": `Printory`, "value": `printory` },
        { "label": `Treesprint`, "value": `treesprint` },
        { "label": `Bullstart`, "value": `bullstart` },
        // { "label": `Other`, "value": `other` },
    ];
    // const list_manufacturer = [
    //     { "label": `Gildan`, "value": `gildan`, "enabled": ["flashship", "hmfulfill", "lenful", "printeeshub"] },
    //     { "label": `Bella canvas`, "value": `bellacanvas`, "enabled": ["flashship", "hmfulfill", "lenful"] },
    //     { "label": `Flash POD`, "value": `flashpod`, "enabled": ["flashship"] },
    //     { "label": `Comfort`, "value": `comfort`, "enabled": ["flashship", "hmfulfill", "lenful"] },
    //     { "label": `Tote bag`, "value": `totebag`, "enabled": ["flashship", "hmfulfill", "lenful"] },

    //     { "label": `Gildan Fast US`, "value": `gildanfastus`, "enabled": ["mangoteeprints"] },
    //     { "label": `Bella canvas Fast US`, "value": `bellacanvasfastus`, "enabled": ["mangoteeprints"] },
    //     { "label": `Comfort Fast US`, "value": `comfortfastus`, "enabled": ["mangoteeprints"] },
    //     { "label": `Tote bag Fast US`, "value": `totebagfastus`, "enabled": ["mangoteeprints"] },

    //     { "label": `Gildan Tiktok`, "value": `gildantiktok`, "enabled": ["mangoteeprints", "gearment", "a2kecom"] },
    //     { "label": `Bella canvas Tiktok`, "value": `bellacanvastiktok`, "enabled": ["mangoteeprints", "gearment", "a2kecom"] },
    //     { "label": `Comfort Tiktok`, "value": `comforttiktok`, "enabled": ["mangoteeprints", "gearment", "a2kecom"] },

    //     { "label": `Gildan US1`, "value": `gildanus1`, "enabled": ["mangoteeprints"] },
    //     { "label": `Bella canvas US1`, "value": `bellacanvasus1`, "enabled": ["mangoteeprints"] },
    //     { "label": `Comfort US1`, "value": `comfortus1`, "enabled": ["mangoteeprints"] },

    //     { "label": `All Over Print`, "value": `alloverprint`, "enabled": ["onospod"] },
    // ];
    // const list_type = [
    //     { "label": `T-Shirt G5000`, "value": `tshirt_g5000`, "enabled": ["gildan"] },
    //     { "label": `Sweatshirt G18000`, "value": `sweatshirt_g18000`, "enabled": ["gildan"] },
    //     { "label": `Hoodie G18500`, "value": `hoodie_g18500`, "enabled": ["gildan"] },
    //     { "label": `Tank top G2200`, "value": `tanktop_g2200`, "enabled": ["gildan"] },
    //     { "label": `T-Shirt B3001`, "value": `tshirt_b3001`, "enabled": ["bellacanvas"] },
    //     { "label": `T-Shirt FLPOD`, "value": `tshirt_flpod`, "enabled": ["flashpod"] },
    //     { "label": `T-Shirt C1717`, "value": `tshirt_c1717`, "enabled": ["comfort"] },
    //     { "label": `Tote bag`, "value": `totebag`, "enabled": ["totebag"] },

    //     { "label": `T-Shirt 5000`, "value": `tshirt_5000_fastus`, "enabled": ["gildanfastus"] },
    //     { "label": `Sweatshirt 18000`, "value": `sweatshirt_18000_fastus`, "enabled": ["gildanfastus"] },
    //     { "label": `Hoodie 18500`, "value": `hoodie_18500_fastus`, "enabled": ["gildanfastus"] },
    //     { "label": `Tank top 2200`, "value": `tanktop_2200`, "enabled": ["gildanfastus"] },

    //     { "label": `T-Shirt 5000`, "value": `tshirt_5000_tiktok`, "enabled": ["gildantiktok"] },
    //     { "label": `Sweatshirt 18000`, "value": `sweatshirt_18000_tiktok`, "enabled": ["gildantiktok"] },
    //     { "label": `Hoodie 18500`, "value": `hoodie_18500_tiktok`, "enabled": ["gildantiktok"] },

    //     { "label": `T-Shirt 5000`, "value": `tshirt_5000_us1`, "enabled": ["gildanus1"] },
    //     { "label": `Sweatshirt 18000`, "value": `sweatshirt_18000_us1`, "enabled": ["gildanus1"] },
    //     { "label": `Hoodie 18500`, "value": `hoodie_18500_us1`, "enabled": ["gildanus1"] },

    //     { "label": `T-Shirt 3001`, "value": `tshirt_3001`, "enabled": ["bellacanvasfastus", "bellacanvastiktok", "bellacanvasus1"] },
    //     { "label": `T-Shirt 1717`, "value": `tshirt_1717`, "enabled": ["comfortfastus", "comforttiktok", "comfortus1"] },
    //     { "label": `Tote bag`, "value": `totebag`, "enabled": ["totebagfastus"] },

    //     { "label": `Premium 3D T-Shirt`, "value": `premium3dtshirt`, "enabled": ["alloverprint"] },
    //     { "label": `Sweatshirt Unisex`, "value": `sweatshirtunisex`, "enabled": ["alloverprint"] },
    //     { "label": `Hoodie`, "value": `hoodie`, "enabled": ["alloverprint"] },
    //     { "label": `Tank Top Men`, "value": `tanktopmen`, "enabled": ["alloverprint"] },
    //     { "label": `Tank Top Women`, "value": `tanktopwomen`, "enabled": ["alloverprint"] },
    //     { "label": `Premium Polo Shirt Men`, "value": `premiumpoloshirtmen`, "enabled": ["alloverprint"] },
    //     { "label": `Premium Polo Shirt Women`, "value": `premiumpoloshirtwomen`, "enabled": ["alloverprint"] },
    // ];
    // const list_size = [
    //     { "label": `S`, "value": `s`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `M`, "value": `m`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `L`, "value": `l`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `XL`, "value": `xl`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `2XL`, "value": `2xl`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `3XL`, "value": `3xl`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `4XL`, "value": `4xl`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tshirt_b3001", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tshirt_3001", "tshirt_1717", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `5XL`, "value": `5xl`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tshirt_b3001", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tshirt_3001", "premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    // ];
    // const list_color = [
    //     { "label": `Black`, "value": `black`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "totebag", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717"] },
    //     { "label": `White`, "value": `white`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_b3001", "tshirt_flpod", "tshirt_c1717", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "tshirt_3001", "tshirt_1717"] },
    //     { "label": `Sportgrey`, "value": `sportgrey`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200"] },
    //     { "label": `Sand`, "value": `sand`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok"] },
    //     { "label": `Forestgreen`, "value": `forestgreen`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok"] },
    //     { "label": `Lightpink`, "value": `lightpink`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok"] },
    //     { "label": `Navy`, "value": `navy`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "hoodie_g18500", "tanktop_g2200", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_fastus", "hoodie_18500_tiktok", "hoodie_18500_us1", "tanktop_2200", "sweatshirt_18000_tiktok", "tshirt_3001", "tshirt_1717"] },
    //     { "label": `Militarygreen`, "value": `militarygreen`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok"] },
    //     { "label": `Maroon`, "value": `maroon`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "tshirt_3001"] },
    //     { "label": `Red`, "value": `red`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "tshirt_3001", "tshirt_1717"] },
    //     { "label": `Royalblue`, "value": `royalblue`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "sweatshirt_18000_fastus"] },
    //     { "label": `Royal`, "value": `royal`, "enabled": ["tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_tiktok"] },
    //     { "label": `Ashgrey`, "value": `ashgrey`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "sweatshirt_18000_fastus"] },
    //     { "label": `Ash`, "value": `ash`, "enabled": ["tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_tiktok", "sweatshirt_18000_us1", "hoodie_18500_tiktok", "tshirt_3001"] },
    //     { "label": `Lightblue`, "value": `lightblue`, "enabled": ["tshirt_g5000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "sweatshirt_18000_tiktok", "hoodie_18500_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_tiktok", "tshirt_3001"] },
    //     { "label": `Charcoal`, "value": `charcoal`, "enabled": ["tshirt_g5000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1"] },
    //     { "label": `Darkheather`, "value": `darkheather`, "enabled": ["tshirt_g5000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "sweatshirt_18000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Darkgreyheather`, "value": `darkgreyheather`, "enabled": ["tshirt_b3001", "tshirt_3001"] },
    //     { "label": `Purple`, "value": `purple`, "enabled": ["tshirt_g5000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_tiktok"] },
    //     { "label": `Orange`, "value": `orange`, "enabled": ["tshirt_g5000", "sweatshirt_g18000", "tshirt_5000_fastus", "tshirt_5000_tiktok", "tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "sweatshirt_18000_fastus", "sweatshirt_18000_tiktok", "tshirt_3001"] },
    //     { "label": `Natural`, "value": `natural`, "enabled": ["tshirt_b3001", "totebag", "tshirt_3001", "tshirt_5000_tiktok"] },
    //     { "label": `Pepper`, "value": `pepper`, "enabled": ["tshirt_c1717", "tshirt_1717"] },
    //     { "label": `Ivory`, "value": `ivory`, "enabled": ["tshirt_c1717", "tshirt_1717"] },
    //     { "label": `Moss`, "value": `moss`, "enabled": ["tshirt_1717"] },
    //     { "label": `Bluejean`, "value": `bluejean`, "enabled": ["tshirt_1717"] },
    //     { "label": `Crunchberry`, "value": `crunchberry`, "enabled": ["tshirt_1717"] },
    //     { "label": `Graphite`, "value": `graphite`, "enabled": ["tshirt_1717"] },
    //     { "label": `Grey`, "value": `grey`, "enabled": ["tshirt_1717"] },
    //     { "label": `Yam`, "value": `yam`, "enabled": ["tshirt_1717"] },
    //     { "label": `As Design`, "value": `asdesign`, "enabled": ["premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `Same Design`, "value": `samedesign`, "enabled": ["premium3dtshirt", "sweatshirtunisex", "hoodie", "tanktopmen", "tanktopwomen", "premiumpoloshirtmen", "premiumpoloshirtwomen"] },
    //     { "label": `Antiqueirishgreen`, "value": `antiqueirishgreen`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Antiqueorange`, "value": `antiqueorange`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Antiquesapphire`, "value": `antiquesapphire`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Azalea`, "value": `azalea`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1"] },
    //     { "label": `Cardinalred`, "value": `cardinalred`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Carolinablue`, "value": `carolinablue`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Cobalt`, "value": `cobalt`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Coralsilk`, "value": `coralsilk`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Cornsilk`, "value": `cornsilk`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Daisy`, "value": `daisy`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Darkchocolate`, "value": `darkchocolate`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Gold`, "value": `gold`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "tshirt_3001"] },
    //     { "label": `Graphiteheather`, "value": `graphiteheather`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Heliconia`, "value": `heliconia`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1", "tshirt_1717"] },
    //     { "label": `Icegrey`, "value": `icegrey`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Irishgreen`, "value": `irishgreen`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Kiwi`, "value": `kiwi`, "enabled": ["tshirt_5000_us1", "sweatshirt_18000_us1", "tshirt_1717"] },
    //     { "label": `Lime`, "value": `lime`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Turfgreen`, "value": `turfgreen`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Tweed`, "value": `tweed`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Electricgreen`, "value": `electricgreen`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Heathernavy`, "value": `heathernavy`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Heatherred`, "value": `heatherred`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Tropicalblue`, "value": `tropicalblue`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Mintgreen`, "value": `mintgreen`, "enabled": ["tshirt_5000_us1"] },
    //     { "label": `Antiquecherryred`, "value": `antiquecherryred`, "enabled": ["sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Cherryred`, "value": `cherryred`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Garnet`, "value": `garnet`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Heathersportscarletred`, "value": `heathersportscarletred`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Heathersportdarkgreen`, "value": `heathersportdarkgreen`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Heathersportdarknavy`, "value": `heathersportdarknavy`, "enabled": ["sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Heathersportdarkmaroon`, "value": `heathersportdarkmaroon`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Heathersportroyal`, "value": `heathersportroyal`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Indigoblue`, "value": `indigoblue`, "enabled": ["sweatshirt_18000_us1", "hoodie_18500_us1"] },
    //     { "label": `Safetygreen`, "value": `safetygreen`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Sapphire`, "value": `sapphire`, "enabled": ["sweatshirt_18000_us1"] },
    //     { "label": `Safetyorange`, "value": `safetyorange`, "enabled": ["hoodie_18500_us1"] },
    //     { "label": `Aqua`, "value": `aqua`, "enabled": ["tshirt_3001"] },
    //     { "label": `Army`, "value": `army`, "enabled": ["tshirt_3001"] },
    //     { "label": `Athleticheather`, "value": `athleticheather`, "enabled": ["tshirt_3001"] },
    //     { "label": `Babyblue`, "value": `babyblue`, "enabled": ["tshirt_3001"] },
    //     { "label": `Berry`, "value": `berry`, "enabled": ["tshirt_3001", "tshirt_1717"] },
    //     { "label": `Blackheather`, "value": `blackheather`, "enabled": ["tshirt_3001"] },
    //     { "label": `Canvasred`, "value": `canvasred`, "enabled": ["tshirt_3001"] },
    //     { "label": `Cardinal`, "value": `cardinal`, "enabled": ["tshirt_3001"] },
    //     { "label": `Charitypink`, "value": `charitypink`, "enabled": ["tshirt_3001"] },
    //     { "label": `Darkolive`, "value": `darkolive`, "enabled": ["tshirt_3001"] },
    //     { "label": `Deepheather`, "value": `deepheather`, "enabled": ["tshirt_3001"] },
    //     { "label": `Forest`, "value": `forest`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherclay`, "value": `heatherclay`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathercolumbiablue`, "value": `heathercolumbiablue`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathergreen`, "value": `heathergreen`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathericeblue`, "value": `heathericeblue`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherkelly`, "value": `heatherkelly`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathermauve`, "value": `heathermauve`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathermint`, "value": `heathermint`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathernavy`, "value": `heathernavy`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherolive`, "value": `heatherolive`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherpeach`, "value": `heatherpeach`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherraspberry`, "value": `heatherraspberry`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherred`, "value": `heatherred`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherslate`, "value": `heatherslate`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherteampurple`, "value": `heatherteampurple`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathertrueroyal`, "value": `heathertrueroyal`, "enabled": ["tshirt_3001"] },
    //     { "label": `Kelly`, "value": `kelly`, "enabled": ["tshirt_3001"] },
    //     { "label": `Maizeyellow`, "value": `maizeyellow`, "enabled": ["tshirt_3001"] },
    //     { "label": `Mint`, "value": `mint`, "enabled": ["tshirt_3001"] },
    //     { "label": `Olive`, "value": `olive`, "enabled": ["tshirt_3001"] },
    //     { "label": `Pink`, "value": `pink`, "enabled": ["tshirt_3001"] },
    //     { "label": `Silver`, "value": `silver`, "enabled": ["tshirt_3001"] },
    //     { "label": `Softpink`, "value": `softpink`, "enabled": ["tshirt_3001"] },
    //     { "label": `Solidblackblend`, "value": `solidblackblend`, "enabled": ["tshirt_3001"] },
    //     { "label": `Teal`, "value": `teal`, "enabled": ["tshirt_3001"] },
    //     { "label": `Teampurple`, "value": `teampurple`, "enabled": ["tshirt_3001"] },
    //     { "label": `Trueroyal`, "value": `trueroyal`, "enabled": ["tshirt_3001"] },
    //     { "label": `Vintageblack`, "value": `vintageblack`, "enabled": ["tshirt_3001"] },
    //     { "label": `Yellow`, "value": `yellow`, "enabled": ["tshirt_3001"] },
    //     { "label": `Asphalt`, "value": `asphalt`, "enabled": ["tshirt_3001"] },
    //     { "label": `Darkgrey`, "value": `darkgrey`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherprismnatural`, "value": `heatherprismnatural`, "enabled": ["tshirt_3001"] },
    //     { "label": `Steelblue`, "value": `steelblue`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherseagreen`, "value": `heatherseagreen`, "enabled": ["tshirt_3001"] },
    //     { "label": `Leaf`, "value": `leaf`, "enabled": ["tshirt_3001"] },
    //     { "label": `Softcream`, "value": `softcream`, "enabled": ["tshirt_3001"] },
    //     { "label": `Brown`, "value": `brown`, "enabled": ["tshirt_3001"] },
    //     { "label": `Burntorange`, "value": `burntorange`, "enabled": ["tshirt_3001"] },
    //     { "label": `Coral`, "value": `coral`, "enabled": ["tshirt_3001"] },
    //     { "label": `Deepteal`, "value": `deepteal`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatheraqua`, "value": `heatheraqua`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heathermaroon`, "value": `heathermaroon`, "enabled": ["tshirt_3001"] },
    //     { "label": `Lilac`, "value": `lilac`, "enabled": ["tshirt_3001"] },
    //     { "label": `Pebble`, "value": `pebble`, "enabled": ["tshirt_3001"] },
    //     { "label": `Sunset`, "value": `sunset`, "enabled": ["tshirt_3001"] },
    //     { "label": `Turquoise`, "value": `turquoise`, "enabled": ["tshirt_3001"] },
    //     { "label": `Vintagewhite`, "value": `vintagewhite`, "enabled": ["tshirt_3001"] },
    //     { "label": `Heatherprismlilac`, "value": `heatherprismlilac`, "enabled": ["tshirt_3001"] },
    //     { "label": `Oxbloodblack`, "value": `oxbloodblack`, "enabled": ["tshirt_3001"] },
    //     { "label": `Banana`, "value": `banana`, "enabled": ["tshirt_1717"] },
    //     { "label": `Bay`, "value": `bay`, "enabled": ["tshirt_1717"] },
    //     { "label": `Blossom`, "value": `blossom`, "enabled": ["tshirt_1717"] },
    //     { "label": `Bluespruce`, "value": `bluespruce`, "enabled": ["tshirt_1717"] },
    //     { "label": `Brick`, "value": `brick`, "enabled": ["tshirt_1717"] },
    //     { "label": `Brightsalmon`, "value": `brightsalmon`, "enabled": ["tshirt_1717"] },
    //     { "label": `Burntorange`, "value": `burntorange`, "enabled": ["tshirt_1717"] },
    //     { "label": `Butter`, "value": `butter`, "enabled": ["tshirt_1717"] },
    //     { "label": `Chalkymint`, "value": `chalkymint`, "enabled": ["tshirt_1717"] },
    //     { "label": `Chambray`, "value": `chambray`, "enabled": ["tshirt_1717"] },
    //     { "label": `Chili`, "value": `chili`, "enabled": ["tshirt_1717"] },
    //     { "label": `Citrus`, "value": `citrus`, "enabled": ["tshirt_1717"] },
    //     { "label": `Crimson`, "value": `crimson`, "enabled": ["tshirt_1717"] },
    //     { "label": `Cumin`, "value": `cumin`, "enabled": ["tshirt_1717"] },
    //     { "label": `Denim`, "value": `denim`, "enabled": ["tshirt_1717"] },
    //     { "label": `Floblue`, "value": `floblue`, "enabled": ["tshirt_1717"] },
    //     { "label": `Granite`, "value": `granite`, "enabled": ["tshirt_1717"] },
    //     { "label": `Grape`, "value": `grape`, "enabled": ["tshirt_1717"] },
    //     { "label": `Grass`, "value": `grass`, "enabled": ["tshirt_1717"] },
    //     { "label": `Hemp`, "value": `hemp`, "enabled": ["tshirt_1717"] },
    //     { "label": `Iceblue`, "value": `iceblue`, "enabled": ["tshirt_1717"] },
    //     { "label": `Islandreef`, "value": `islandreef`, "enabled": ["tshirt_1717"] },
    //     { "label": `Khaki`, "value": `khaki`, "enabled": ["tshirt_1717"] },
    //     { "label": `Lagoonblue`, "value": `lagoonblue`, "enabled": ["tshirt_1717"] },
    //     { "label": `Lightgreen`, "value": `lightgreen`, "enabled": ["tshirt_1717"] },
    //     { "label": `Melon`, "value": `melon`, "enabled": ["tshirt_1717"] },
    //     { "label": `Midnight`, "value": `midnight`, "enabled": ["tshirt_1717"] },
    //     { "label": `Mustard`, "value": `mustard`, "enabled": ["tshirt_1717"] },
    //     { "label": `Mysticblue`, "value": `mysticblue`, "enabled": ["tshirt_1717"] },
    //     { "label": `Orchid`, "value": `orchid`, "enabled": ["tshirt_1717"] },
    //     { "label": `Peony`, "value": `peony`, "enabled": ["tshirt_1717"] },
    //     { "label": `Periwinkle`, "value": `periwinkle`, "enabled": ["tshirt_1717"] },
    //     { "label": `Royalcaribe`, "value": `royalcaribe`, "enabled": ["tshirt_1717"] },
    //     { "label": `Sage`, "value": `sage`, "enabled": ["tshirt_1717"] },
    //     { "label": `Sandstone`, "value": `sandstone`, "enabled": ["tshirt_1717"] },
    //     { "label": `Seafoam`, "value": `seafoam`, "enabled": ["tshirt_1717"] },
    //     { "label": `Terracotta`, "value": `terracotta`, "enabled": ["tshirt_1717"] },
    //     { "label": `Topazblue`, "value": `topazblue`, "enabled": ["tshirt_1717"] },
    //     { "label": `Truenavy`, "value": `truenavy`, "enabled": ["tshirt_1717"] },
    //     { "label": `Vineyard`, "value": `vineyard`, "enabled": ["tshirt_1717"] },
    //     { "label": `Violet`, "value": `violet`, "enabled": ["tshirt_1717"] },
    //     { "label": `Washeddenim`, "value": `washeddenim`, "enabled": ["tshirt_1717"] },
    //     { "label": `Watermelon`, "value": `watermelon`, "enabled": ["tshirt_1717"] },
    // ];
    // const list_shipping_method = [
    //     { "label": `FirstClass`, "value": `1`, "enabled": ["flashship"] },
    //     { "label": `Priority`, "value": `2`, "enabled": ["flashship"] },
    //     { "label": `RushProduction`, "value": `3`, "enabled": ["flashship"] },
    //     { "label": `Expedite`, "value": `6`, "enabled": ["flashship"] },

    //     { "label": `Standard`, "value": `standard`, "enabled": ["mangoteeprints"] },
    //     { "label": `Priority`, "value": `priority`, "enabled": ["mangoteeprints"] },
    //     { "label": `Express`, "value": `express`, "enabled": ["mangoteeprints"] },
    //     { "label": `Rush`, "value": `rush`, "enabled": ["mangoteeprints"] },
    //     { "label": `Expedite`, "value": `expedite`, "enabled": ["mangoteeprints"] },

    //     { "label": `Standard`, "value": `0`, "enabled": ["gearment"] },
    //     { "label": `Fastship 2days`, "value": `1`, "enabled": ["gearment"] },
    //     { "label": `Ground`, "value": `2`, "enabled": ["gearment"] },
    //     { "label": `Stamp`, "value": `3`, "enabled": ["gearment"] },

    //     { "label": `Standard`, "value": `1`, "enabled": ["hmfulfill",] },
    //     { "label": `Priority`, "value": `3`, "enabled": ["hmfulfill"] },

    //     // { "label": `Standard`, "value": `0`, "enabled": ["lenful"] },
    //     // { "label": `Ground`, "value": `1`, "enabled": ["lenful"] },
    //     // { "label": `Express`, "value": `2`, "enabled": ["lenful"] },
    //     // { "label": `Special`, "value": `4`, "enabled": ["lenful"] },
    //     // { "label": `Us Island`, "value": `5`, "enabled": ["lenful"] },
    //     // { "label": `WW Standard`, "value": `6`, "enabled": ["lenful"] },
    //     { "label": `Shipping By Platform`, "value": `7`, "enabled": ["lenful"] },
    //     // { "label": `Shipping By Seller`, "value": `8`, "enabled": ["lenful"] },

    //     { "label": `Shipping By Tiktok`, "value": `sbtt`, "enabled": ["onospod"] },
    //     // { "label": `Onos Express`, "value": `onosexpress`, "enabled": ["onospod"] },
    //     // { "label": `COD`, "value": `cod`, "enabled": ["onospod"] },

    //     { "label": `Standard Ship`, "value": `standard_ship`, "enabled": ["a2kecom"] },
    //     { "label": `Ground Ship`, "value": `ground_ship`, "enabled": ["a2kecom"] },
    //     { "label": `Fast Ship`, "value": `fast_ship`, "enabled": ["a2kecom"] },

    //     { "label": `Standard`, "value": `standard`, "enabled": ["printeeshub"] },
    //     { "label": `Rush Product`, "value": `rush_product`, "enabled": ["printeeshub"] },
    //     { "label": `Expedite Tiktok`, "value": `expedite_tiktok`, "enabled": ["printeeshub"] },
    // ];

    // const list_printing_area = [
    //     { "label": `One side`, "value": `oneside`, "enabled": ["lenful"] },
    //     { "label": `Both sides`, "value": `bothsides`, "enabled": ["lenful"] },
    // ];

    const prevValues = useRef({ dateStart, dateEnd, page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type });

    useEffect(() => {
        if (
            date_type !== "" &&
            (prevValues.current.dateStart === dateStart && prevValues.current.dateEnd === dateEnd) &&
            prevValues.current.page === page &&
            prevValues.current.sizePerPage === sizePerPage &&
            prevValues.current.searchText === searchText &&
            prevValues.current.filter_printer === filter_printer &&
            prevValues.current.filter_shop_code === filter_shop_code &&
            prevValues.current.filter_status === filter_status &&
            prevValues.current.filter_work_status === filter_work_status &&
            prevValues.current.filter_staff_note === filter_staff_note &&
            prevValues.current.filter_staff === filter_staff &&
            prevValues.current.filter_order_design === filter_order_design &&
            prevValues.current.filter_shipping_type === filter_shipping_type
        ) {
            return;
        }
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        prevValues.current = { dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type };

        getListOrders(page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart_tmp, dateEnd_tmp);
    }, [getListOrders, page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart, dateEnd, date_type]);

    useEffect(() => {
        if (window.location.pathname.indexOf("/orders") > -1 && tab_order) {
            navigate('/admin/orders');
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setPage(1);
        setSizePerPage(10);

        // if (date_type === "") {
        //     let date_start = new Date();
        //     date_start = convertTZ(date_start, "Asia/Ho_Chi_Minh");
        //     date_start.setHours(0, 0, 0, 0);
        //     setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

        //     let date_end = new Date();
        //     date_end = convertTZ(date_end, "Asia/Ho_Chi_Minh");
        //     date_end.setHours(23, 59, 59, 999);
        //     setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        // }
        if (date_type === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start, "Asia/Ho_Chi_Minh");
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date();
            date_end = convertTZ(date_end, "Asia/Ho_Chi_Minh");
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start, "Asia/Ho_Chi_Minh");
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start, "Asia/Ho_Chi_Minh");
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start, "Asia/Ho_Chi_Minh");
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "this_month") {
            let date = new Date();
            date = convertTZ(date, "Asia/Ho_Chi_Minh");
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "last_month") {
            let date = new Date();
            date = convertTZ(date, "Asia/Ho_Chi_Minh");
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "this_year") {
            let date = new Date();
            date = convertTZ(date, "Asia/Ho_Chi_Minh");
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
        if (date_type === "last_year") {
            let date = new Date();
            date = convertTZ(date, "Asia/Ho_Chi_Minh");
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);
            setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        }
    }, [date_type]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        var printer = {};
        for (var i = 0; i < listorders.length; i++) {
            if (listorders[i].printer) {
                printer = {
                    ...printer,
                    [listorders[i]._id]: {
                        _id: listorders[i]._id,
                        printer: {
                            ...listorders[i].printer
                        },
                        page,
                        sizePerPage,
                        searchText,
                        filter_printer,
                        filter_shop_code,
                        filter_status,
                        filter_work_status,
                        filter_staff_note,
                        filter_staff,
                        filter_order_design,
                        filter_shipping_type,
                        dateStart,
                        dateEnd,
                    }
                }
            }
        }
        setPrinterTmp(printer);
    }, [listorders]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 9999 });
    }, [getShops]);

    useEffect(() => {
        getStaffs({ page: 1, sizeperpage: 9999 });
    }, [getStaffs]);

    // const onChange = (e, row = [], formatExtraData, line_item = [], name = "") => {
    //     var dateStart_tmp = formatExtraData.dateStart;
    //     var dateEnd_tmp = formatExtraData.dateEnd;
    //     if (formatExtraData.date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }

    //     var printer = {
    //         [line_item.id]: {
    //             ...row?.printer?.[line_item.id],
    //             ...printer_tmp?.[row._id]?.printer?.[line_item.id],
    //             [name]: e?.value?.toLowerCase() || e?.target?.value || ""
    //         }
    //     };
    //     setPrinterTmp((prev) => ({
    //         ...prev,
    //         [row._id]: {
    //             _id: row._id,
    //             printer: {
    //                 ...prev?.[row._id]?.printer,
    //                 ...printer
    //             },
    //             page: formatExtraData.page,
    //             sizePerPage: formatExtraData.sizePerPage,
    //             searchText: formatExtraData.searchText,
    //             filter_printer: formatExtraData.filter_printer,
    //             filter_shop_code: formatExtraData.filter_shop_code,
    //             filter_status: formatExtraData.filter_status,
    //             filter_work_status: formatExtraData.filter_work_status,
    //             filter_staff_note: formatExtraData.filter_staff_note,
    //             filter_staff: formatExtraData.filter_staff,
    //             filter_order_design: formatExtraData.filter_order_design,
    //             filter_shipping_type: formatExtraData.filter_shipping_type,
    //             dateStart: dateStart_tmp,
    //             dateEnd: dateEnd_tmp,
    //         }
    //     }));
    // }

    // const onChangeType = (e, row = [], formatExtraData, line_item = []) => {
    //     var dateStart_tmp = formatExtraData.dateStart;
    //     var dateEnd_tmp = formatExtraData.dateEnd;
    //     if (formatExtraData.date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }

    //     var printer = {
    //         [line_item.id]: {
    //             ...row?.printer?.[line_item.id],
    //             ...printer_tmp?.[row._id]?.printer?.[line_item.id],
    //             type: e?.value || "",
    //             shipping_method: "",
    //             color: "",
    //             size: "",
    //             base_cost: 0,
    //         }
    //     };
    //     setPrinterTmp((prev) => ({
    //         ...prev,
    //         [row._id]: {
    //             _id: row._id,
    //             printer: {
    //                 ...prev?.[row._id]?.printer,
    //                 ...printer
    //             },
    //             page: formatExtraData.page,
    //             sizePerPage: formatExtraData.sizePerPage,
    //             searchText: formatExtraData.searchText,
    //             filter_printer: formatExtraData.filter_printer,
    //             filter_shop_code: formatExtraData.filter_shop_code,
    //             filter_status: formatExtraData.filter_status,
    //             filter_work_status: formatExtraData.filter_work_status,
    //             filter_staff_note: formatExtraData.filter_staff_note,
    //             filter_staff: formatExtraData.filter_staff,
    //             filter_order_design: formatExtraData.filter_order_design,
    //             filter_shipping_type: formatExtraData.filter_shipping_type,
    //             dateStart: dateStart_tmp,
    //             dateEnd: dateEnd_tmp,
    //         }
    //     }));
    // }

    // const onChangeManuFacturer = (e, row = [], formatExtraData, line_item = []) => {
    //     var dateStart_tmp = formatExtraData.dateStart;
    //     var dateEnd_tmp = formatExtraData.dateEnd;
    //     if (formatExtraData.date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }

    //     var printer = {
    //         [line_item.id]: {
    //             ...row?.printer?.[line_item.id],
    //             ...printer_tmp?.[row._id]?.printer?.[line_item.id],
    //             manufacturer: e?.value || "",
    //             type: "",
    //             shipping_method: "",
    //             color: "",
    //             size: "",
    //             base_cost: 0,
    //             printing_area: "",
    //         }
    //     };
    //     setPrinterTmp((prev) => ({
    //         ...prev,
    //         [row._id]: {
    //             _id: row._id,
    //             printer: {
    //                 ...prev?.[row._id]?.printer,
    //                 ...printer
    //             },
    //             page: formatExtraData.page,
    //             sizePerPage: formatExtraData.sizePerPage,
    //             searchText: formatExtraData.searchText,
    //             filter_printer: formatExtraData.filter_printer,
    //             filter_shop_code: formatExtraData.filter_shop_code,
    //             filter_status: formatExtraData.filter_status,
    //             filter_work_status: formatExtraData.filter_work_status,
    //             filter_staff_note: formatExtraData.filter_staff_note,
    //             filter_staff: formatExtraData.filter_staff,
    //             filter_order_design: formatExtraData.filter_order_design,
    //             filter_shipping_type: formatExtraData.filter_shipping_type,
    //             dateStart: dateStart_tmp,
    //             dateEnd: dateEnd_tmp,
    //         }
    //     }));
    // }

    // const onChangePrinter = (e, row = [], formatExtraData, line_item = []) => {
    //     var dateStart_tmp = formatExtraData.dateStart;
    //     var dateEnd_tmp = formatExtraData.dateEnd;
    //     if (formatExtraData.date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }

    //     var printer = {
    //         [line_item.id]: {
    //             ...row?.printer?.[line_item.id],
    //             ...printer_tmp?.[row._id]?.printer?.[line_item.id],
    //             printer: e?.value || "",
    //             manufacturer: "",
    //             type: "",
    //             shipping_method: "",
    //             color: "",
    //             size: "",
    //             base_cost: 0,
    //             printing_area: 0,
    //         }
    //     };
    //     setPrinterTmp((prev) => ({
    //         ...prev,
    //         [row._id]: {
    //             _id: row._id,
    //             printer: {
    //                 ...prev?.[row._id]?.printer,
    //                 ...printer
    //             },
    //             page: formatExtraData.page,
    //             sizePerPage: formatExtraData.sizePerPage,
    //             searchText: formatExtraData.searchText,
    //             filter_printer: formatExtraData.filter_printer,
    //             filter_shop_code: formatExtraData.filter_shop_code,
    //             filter_status: formatExtraData.filter_status,
    //             filter_work_status: formatExtraData.filter_work_status,
    //             filter_staff_note: formatExtraData.filter_staff_note,
    //             filter_staff: formatExtraData.filter_staff,
    //             filter_order_design: formatExtraData.filter_order_design,
    //             filter_shipping_type: formatExtraData.filter_shipping_type,
    //             dateStart: dateStart_tmp,
    //             dateEnd: dateEnd_tmp,
    //         }
    //     }));
    // }

    const onChangeFilterPrinter = (e) => {
        var filter_printer_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterPrinter(filter_printer_tmp);
    }

    const onChangeFilterShopCode = (e) => {
        var filter_shop_code_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterShopCode(filter_shop_code_tmp);
    }

    const onChangeFilterStatus = (e) => {
        var filter_status_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterStatus(filter_status_tmp);
    }

    const onChangeFilterWorkStatus = (e) => {
        var filter_work_status_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterWorkStatus(filter_work_status_tmp);
    }

    const onChangeFilterStaffNote = (e) => {
        var filter_staff_note_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterStaffNote(filter_staff_note_tmp);
    }

    const onChangeFilterOrderDesign = (e) => {
        setFilterOrderDesign(e?.[0]?.value || "");
    }

    const onChangeFilterShippingType = (e) => {
        setFilterShippingType(e?.[0]?.value || "");
    }

    const onChangeFilterStaff = (e) => {
        var filter_staff_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilterStaff(filter_staff_tmp);
    }

    const onChangeDateType = (e) => {
        setDateType(e?.[0]?.value || "");
    }

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(10);

        let date_start = new Date(start);
        // date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        // date_end.setHours(23, 59, 59, 999);

        setDateStart(date_start.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
        setDateEnd(date_end.getTime() + getRange2TZ(getTimezoneOffset(new Date(), "Asia/Ho_Chi_Minh")) * 60 * 60 * 1000);
    };

    // const handleBeforeSaveCell = (oldValue, newValue, row, column) => {
    //     var dateStart_tmp = dateStart;
    //     var dateEnd_tmp = dateEnd;
    //     if (date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }
    //     saveEditOrder({ _id: row._id, [column.dataField]: newValue, page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp });
    // }

    const onClickOpenModalEditDesign = (row = [], formatExtraData, line_item) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
                line_item
            }
        }
        setIsOpenModalEditDesign(!isOpenModalEditDesign);
        setEditDesign(row);
    };

    const onClickOpenModalProductSettings = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalProductSettings(!isOpenModalProductSettings);
        setProductSettings(row);
    };

    const onClickOpenModalEditOrderStatus = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalEditOrderStatus(!isOpenModalEditOrderStatus);
        setEditOrderStatus(row);
    };

    const onClickOpenModalImportTrackingV2 = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalImportTrackingV2(!isOpenModalImportTrackingV2);
        setImportTrackingV2(row);
    };

    const onClickOpenModalBuyLabel = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalBuyLabel(!isOpenModalBuyLabel);
        setBuyLabel(row);
    };

    const onClickOpenModalSplitOrder = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalSplitOrder(!isOpenModalSplitOrder);
        setSplitOrder(row);
    };

    const onClickOpenModalUploadInvoice = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        setIsOpenModalUploadInvoice(!isOpenModalUploadInvoice);
        setUploadInvoice(row);
    };

    // const onClickSavePrintPartner = (row = [], formatExtraData) => {
    //     var dateStart_tmp = formatExtraData.dateStart;
    //     var dateEnd_tmp = formatExtraData.dateEnd;
    //     if (formatExtraData.date_type === "") {
    //         dateStart_tmp = "";
    //         dateEnd_tmp = "";
    //     }
    //     formatExtraData.dateStart = dateStart_tmp;
    //     formatExtraData.dateEnd = dateEnd_tmp;
    //     formatExtraData.printer_tmp[row._id].dateStart = dateStart_tmp;
    //     formatExtraData.printer_tmp[row._id].dateEnd = dateEnd_tmp;
    //     saveEditOrder(formatExtraData.printer_tmp[row._id]);
    // }

    const onClickSendToPrinterOrdersSelected = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        var orders_selected_tmp = orders_selected.filter((v, i) => !listorders.some((v2, i2) => v2._id === v && v2.order_status === "worked"));
        sendToPrinter({ _id: orders_selected_tmp.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, setOrdersSelected });
    }

    const onClickCancelToPrinterOrdersSelected = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        var orders_selected_tmp = orders_selected.filter((v, i) => !listorders.some((v2, i2) => v2._id === v && v2.order_status === "worked"));
        cancelToPrinter({ _id: orders_selected_tmp.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp });
    }

    const onClickOpenModalBuyLabelOrdersSelected = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        setIsOpenModalBuyLabel(!isOpenModalBuyLabel);
        var orders_selected_tmp = orders_selected.filter((v, i) => !listorders.some((v2, i2) => v2._id === v && v2.order_status === "worked"));
        setBuyLabel({ _id: orders_selected_tmp.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, setOrdersSelected });
    }

    const onClickOpenModalChangeStatusOrdersSelected = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        setIsOpenModalEditOrderStatus(!isOpenModalEditOrderStatus);
        setEditOrderStatus({ _id: orders_selected.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, setOrdersSelected });
    }

    const onClickMakeOrderComplete = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        makeOrderComplete({ _id: orders_selected.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, setOrdersSelected });
    }

    const onClickSendToPrinter = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
                setOrdersSelected
            }
        }
        sendToPrinter(row);
    }

    const onClickCancelToPrinter = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            var dateStart_tmp = formatExtraData.dateStart;
            var dateEnd_tmp = formatExtraData.dateEnd;
            if (formatExtraData.date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }

            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText,
                filter_printer: formatExtraData.filter_printer,
                filter_shop_code: formatExtraData.filter_shop_code,
                filter_status: formatExtraData.filter_status,
                filter_work_status: formatExtraData.filter_work_status,
                filter_staff_note: formatExtraData.filter_staff_note,
                filter_staff: formatExtraData.filter_staff,
                filter_order_design: formatExtraData.filter_order_design,
                filter_shipping_type: formatExtraData.filter_shipping_type,
                dateStart: dateStart_tmp,
                dateEnd: dateEnd_tmp,
            }
        }
        cancelToPrinter(row);
    }

    const onClickSyncMatchDesign = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        syncMatchDesign({ page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp });
    }

    const onClickCombinePackage = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        var orders_selected_tmp = orders_selected.filter((v, i) => !listorders.some((v2, i2) => v2._id === v && v2.order_status === "worked"));
        combinePackage({ _id: orders_selected_tmp.join(), page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp, setOrdersSelected });
    }

    const onClickOpenModalCustomer = (cell = {}) => {
        setIsOpenModalCustomer(!isOpenModalCustomer);
        setCustomer(cell);
    }

    const onClickOpenModalImportTracking = () => {
        setIsOpenModalImportTracking(!isOpenModalImportTracking);
    }

    const onClickOpenModalExportOrders = () => {
        var dateStart_tmp = dateStart;
        var dateEnd_tmp = dateEnd;
        if (date_type === "") {
            dateStart_tmp = "";
            dateEnd_tmp = "";
        }
        setIsOpenModalExportOrders(!isOpenModalExportOrders);
        setExportOrders({ searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart_tmp, dateEnd_tmp });
    }

    const onClick = (data) => {
        setTab(data);
        if (data === "orders_all") {
            setFilterStatus("");
        }
        if (data === "orders_on_hold") {
            setFilterStatus("ON_HOLD");
        }
        if (data === "orders_awaiting_shipment") {
            setFilterStatus("AWAITING_SHIPMENT");
        }
        if (data === "orders_awaiting_collection") {
            setFilterStatus("AWAITING_COLLECTION");
        }
        if (data === "orders_in_transit") {
            setFilterStatus("IN_TRANSIT");
        }
        if (data === "orders_delivered") {
            setFilterStatus("DELIVERED");
        }
        if (data === "orders_completed") {
            setFilterStatus("COMPLETED");
        }
        if (data === "orders_cancelled") {
            setFilterStatus("CANCELLED");
        }
    };

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const getRefLinkUrl = (refLink = "") => {
        const url = String(refLink || "").trim();
        if (!url) return "";
        if (/^https?:\/\//i.test(url)) return url;
        if (!url.includes(".")) return "";
        return `https://${url}`;
    };

    // const onKeyPress = (e) => {
    //     if ((/^[0-9.]+$/).test(e)) {
    //         e.preventDefault();
    //     }
    // }

    const columns = [{
        field: 'checkbox',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 100,
        headerValueGetter: () => `(${orders_selected.length})`,
    }, {
        field: '_id',
        headerName: t("Actions"),
        editable: false,
        sort: true,
        width: 200,
        resizable: false,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex, formatExtraData = { page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, date_type, dateStart, dateEnd, isLoading, setOrdersSelected } }) => (
            <Fragment>
                <div className="d-flex flex-wrap">
                    <span className="me-2">{totalsize - ((page - 1) * sizePerPage) - rowIndex}</span>
                    <span className=""><FormatterStatus status={row?.order_status} large={true} /></span>
                    {
                        row?.overdue ?
                            <span>
                                {/* {row?.status === "AWAITING_SHIPMENT" && +row?.tts_sla_time - 72000 > Date.now() / 1000 ? <FormatterStatus status={"overdue"} large={true} /> : ""} */}
                                <FormatterStatus status={"overdue"} large={true} />
                            </span>
                        : ""
                    }
                    {
                        row?.ship_late ?
                            <span>
                                <FormatterStatus status={"ship_late"} large={true} />
                            </span>
                        : ""
                    }
                </div>
                {row?.recipient_address?.address_line1 !== "" && row?.order_status !== "cancel" && row?.order_status !== "warehouse_out" && <div className="d-flex flex-wrap mb-3">
                    {
                        row?.order_status !== "worked" ?
                            <button onClick={() => { onClickSendToPrinter(row, formatExtraData) }} className="btn btn-icon btn-active-color-primary btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Send to printer")} disabled={isLoading} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-outline ki-send fs-1 align-middle"></i>
                            </button>
                            : ""
                    }
                    {
                        row?.order_status === "worked" && (row?.status !== "IN_TRANSIT" && row?.status !== "DELIVERED" && row?.status !== "CANCELLED" && row?.status !== "CANCEL") ?
                            <button onClick={() => { onClickCancelToPrinter(row, formatExtraData) }} className="btn btn-icon btn-active-color-danger btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Cancel to printer")} disabled={isLoading} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-outline ki-cross-square fs-1 align-middle"></i>
                            </button>
                            : ""
                    }
                    {
                        row?.order_status !== "worked" && row?.status !== "CANCELLED" && row?.status !== "CANCEL" && row?.shipping_type === "TIKTOK" ?
                            <button onClick={() => { onClickOpenModalBuyLabel(row, formatExtraData) }} className="btn btn-icon btn-active-color-success btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Buy Label")} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-outline ki-handcart fs-1"></i>
                            </button>
                            : ""
                    }
                    {
                        row?.order_status !== "worked" && row?.status !== "CANCELLED" && row?.status !== "CANCEL" && row?.shipping_label === "" ?
                            <button onClick={() => { onClickOpenModalSplitOrder(row, formatExtraData) }} className="btn btn-icon btn-active-color-info btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Split Order")} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-duotone ki-data fs-1">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                    <span className="path3"></span>
                                    <span className="path4"></span>
                                    <span className="path5"></span>
                                </i>
                            </button>
                            : ""
                    }
                    {/* <button onClick={() => { onClickOpenModalEditOrderStatus(row, formatExtraData) }} className="btn btn-icon btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Change Status Order")} style={{ width: "calc(50% - 8px)" }}>
                        <i className="ki-outline ki-notepad-edit fs-1"></i>
                    </button> */}
                    {
                        row?.shipping_type === "SELLER" || row?.order_status !== "worked" ?
                            <button onClick={() => { onClickOpenModalImportTrackingV2(row, formatExtraData) }} className="btn btn-icon btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Import Tracking")} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-outline ki-notepad-edit fs-1"></i>
                            </button>
                            : ""
                    }
                    {row?.user_id !== "" && <button
                        onClick={() => {
                            setEditMember(row);
                        }}
                        className="btn btn-icon btn-active-color-danger btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Chat")}
                        style={{ width: "calc(50% - 8px)" }}
                    >
                        <i className="ki-outline ki-support-24 fs-1"></i>
                    </button>}
                    <button onClick={() => { setOrderRefund(row) }} className="btn btn-icon btn-active-color-danger btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Cancel Order")} style={{ width: "calc(50% - 8px)" }}>
                        <i className="ki-outline ki-cross-circle fs-2"></i>
                    </button>
                    {
                        row?.need_upload_invoice === "NEED_INVOICE" ?
                            <button onClick={() => { onClickOpenModalUploadInvoice(row, formatExtraData) }} className="btn btn-icon btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={row?.need_upload_invoice} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-duotone ki-file-up fs-1">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                            </button>
                            : ""
                    }
                    {
                        (role !== 2 || (role === 2 && teamRole === "staff") || (role === 2 && teamRole === "fulfill")) ?
                            <button onClick={() => { onClickOpenModalProductSettings(row, formatExtraData) }} className="btn btn-icon btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printer Setting")} style={{ width: "calc(50% - 8px)" }}>
                                <i className="ki-outline ki-setting-2 fs-1"></i>
                            </button>
                            : ""
                    }
                </div>}
            </Fragment>
        )
    }, {
        field: 'apiOrderId',
        headerName: t("Order"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        minWidth: 220,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => (
            <Fragment>
                <div className="d-flex flex-column">
                    {row?.status === "CANCELLED" ? <div><div className="" data-tooltip-id="my-tooltip"
                        data-tooltip-content={`${row?.cancellation_initiator}: ${row?.cancel_reason}`}>
                        <FormatterStatus status={row?.status} large={true} /></div>
                        <div className="" data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Cancelled Time")}>{formatterCreateAt(row?.cancel_time * 1000)}</div>
                    </div> : <span className="" ><FormatterStatus status={row?.status} large={true} /></span>}
                    {row?.status === "DELIVERED" || row?.status === "COMPLETED" ? <>
                        <div data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Total Delivery Time (from order creation)")}>
                            ~{((+row?.delivery_time - +row?.create_time) / 60 / 60 / 24).toFixed(2)} Days
                        </div>
                    </> : ""}
                    <span className="">
                        {cell} <button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                            data-tooltip-content={"Copy"}
                            onClick={() => navigator.clipboard.writeText(cell)}
                        >
                            <i className="ki-duotone ki-copy">
                            </i>
                        </button>
                    </span>
                    <span className="" data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Created Time")}>{formatterCreateAt(row?.create_time * 1000)}</span>
                    <span className="" data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Deadline Shipped")}>{formatterCreateAt(row?.delivery_sla_time * 1000)}</span>
                    <span className="">{row?.returnorders?._id && <h5 className="text-danger">Refund issued</h5>}</span>
                    <span className={cx("fw-bold", { "text-primary fs-xl": row?.shipping_type === "TIKTOK", "text-warning fs-xl": row?.shipping_type === "SELLER" })}>{t("Ship By")} {row?.shipping_type}</span>
                    <span className="text-danger fs-xl" data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Split Or Combine Orders")}>{(row?.split_or_combine_tag && row?.split_or_combine_tag !== "none") ? row?.split_or_combine_tag : ""}</span>
                </div>
            </Fragment>
        ),
    }, {
        field: 'profit_summary',
        headerName: t("Profit Summary"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        width: 220,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => {
            var rev = row?.est_amount > 0
                ? row?.est_amount
                : (row?.shipping_type === "TIKTOK"
                    ? ((+row?.payment?.original_total_product_price - +row?.payment?.seller_discount) - 6 / 100 * (+row?.payment?.total_amount + +row?.payment?.platform_discount - +row?.payment?.tax))
                    : ((+row?.payment?.original_total_product_price - +row?.payment?.seller_discount + +row?.payment?.shipping_fee) - 6 / 100 * (+row?.payment?.total_amount + +row?.payment?.platform_discount - +row?.payment?.tax))
                )
            var ff = (row?.base_cost || 0) + (row?.design_fee ? Object.values(row?.design_fee).reduce((a, b) => +a + +b, 0) : 0);
            var prof = (rev - ff) / rev * 100;
            var earn = rev - ff;
            var shipfee = +row?.payment?.original_shipping_fee > 0 && +row?.payment?.shipping_fee === 0 && +row?.payment?.shipping_fee_seller_discount === +row?.payment?.original_shipping_fee ? +row?.payment?.original_shipping_fee : +row?.payment?.original_shipping_fee === 0 && +row?.payment?.shipping_fee === 0 ? 0 : +row?.payment?.original_shipping_fee > +row?.payment?.shipping_fee_seller_discount && +row?.payment?.shipping_fee_seller_discount > 0 && +row?.payment?.shipping_fee === 0 ? +row?.payment?.shipping_fee_seller_discount : +row?.payment?.shipping_fee_seller_discount === 0 && +row?.payment?.shipping_fee > 0 ? 0 : +row?.payment?.shipping_fee_seller_discount;
            return (
                <Fragment>
                    {/* <span className="text-success">Rev: <FormatterMoney money={rev} /></span> / <span className="text-danger">FF: <FormatterMoney money={ff} /></span>
                    <br /> */}
                    Prof: {prof.toFixed(2)}%
                    <br />
                    <span data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Shipping fee not included"}>Earn: <FormatterMoney money={earn} /></span>
                    <br />
                    <span className="text-success" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"After deducting shipping fee"}>Earn payout: <FormatterMoney money={(earn - shipfee).toFixed(2)} /></span>
                    <br />
                    {
                        row?.shipping_service_info_price && +row?.shipping_service_info_price !== 0 ?
                            <span data-tooltip-id="my-tooltip"
                                data-tooltip-content={"Label fee"}>Label fee: <FormatterMoney money={row?.shipping_service_info_price || 0} /></span>
                        : ""
                    }
                    <br />
                    {
                        row?.statement_amount && +row?.statement_amount !== 0 ?
                            <span data-tooltip-id="my-tooltip"
                                data-tooltip-content={"Statement amount"}>Statement amount: <FormatterMoney money={row?.statement_amount || 0} /></span>
                        : ""
                    }
                </Fragment>
            );
        },
    }, {
        field: 'buyer_message',
        headerName: t("Buyer Note"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
    }, {
        field: 'keywords',
        headerName: t("Fulfill Note"),
        editable: true,
        sort: true,
        wrapText: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => <Fragment>{cell} <i className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer"></i></Fragment>,
        // }, {
        //     field: 'printer',
        //     headerName: t("Print partner"),
        //     editable: false,
        //     sort: true,
        //     cellClass: "al-cell-auto-w-table",
        //     autoHeight: true,
        //     width: 650,
        //     cellRenderer: ({ value: cell, data: row, rowIndex, formatExtraData = { page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, date_type, dateStart, dateEnd, printer_tmp } }) => (
        //         <Fragment>
        //             {
        //                 row?.line_items.map((v, i) => {
        //                     return (
        //                         <Fragment>
        //                             <div className="mb-3" style={{ minHeight: "85px", maxHeight: "85px", overflow: "auto" }}>
        //                                 <span className="text-primary fw-semibold d-block fs-7">{v?.sku_name}</span>
        //                                 <div className="d-flex">
        //                                     <Select
        //                                         isDisabled={row?.order_status === "worked"}
        //                                         isClearable
        //                                         name="printer"
        //                                         options={list_printer}
        //                                         className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                         classNamePrefix="select"
        //                                         value={list_printer.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.printer === value)}
        //                                         onChange={(e) => { onChangePrinter(e, row, formatExtraData, v) }}
        //                                         placeholder={t("Select a printer ... ")}
        //                                     />
        //                                     {
        //                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "flashship" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "mangoteeprints" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "gearment" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "other" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "hmfulfill" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "onospod" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "a2kecom" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "printeeshub" ?
        //                                             <Fragment>
        //                                                 <Select
        //                                                     isDisabled={row?.order_status === "worked"}
        //                                                     isClearable
        //                                                     name="manufacturer"
        //                                                     options={list_manufacturer}
        //                                                     className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                     classNamePrefix="select"
        //                                                     value={list_manufacturer.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.manufacturer === value)}
        //                                                     onChange={(e) => { onChangeManuFacturer(e, row, formatExtraData, v) }}
        //                                                     placeholder={t("Select a manufacturer ... ")}
        //                                                     isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.printer)}
        //                                                 />
        //                                                 <Select
        //                                                     isDisabled={row?.order_status === "worked"}
        //                                                     isClearable
        //                                                     isCreate
        //                                                     name="type"
        //                                                     options={list_type}
        //                                                     className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                     classNamePrefix="select"
        //                                                     value={list_type.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.type === value)}
        //                                                     onChange={(e) => { onChangeType(e, row, formatExtraData, v) }}
        //                                                     placeholder={t("Select a type ... ")}
        //                                                     isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.manufacturer)}
        //                                                 />
        //                                             </Fragment>
        //                                             : ""
        //                                     }
        //                                     {
        //                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" ?
        //                                             <Select
        //                                                 isDisabled={row?.order_status === "worked"}
        //                                                 isClearable
        //                                                 name="print_area"
        //                                                 options={list_printing_area}
        //                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                 classNamePrefix="select"
        //                                                 value={list_printing_area.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.printing_area === value)}
        //                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "printing_area") }}
        //                                                 placeholder={t("Select a printing area ... ")}
        //                                                 isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.printer)}
        //                                             />
        //                                             : ""
        //                                     }
        //                                 </div>
        //                                 {
        //                                     printer_tmp?.[row._id]?.printer?.[v.id]?.type ?
        //                                         <Fragment>
        //                                             <div className="d-flex gap-2">
        //                                                 <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
        //                                                     <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
        //                                                         <span className="required">{t("Shipping method")}</span>
        //                                                     </label>
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "flashship" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "mangoteeprints" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "gearment" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "hmfulfill" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "onospod" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "a2kecom" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "printeeshub" ?
        //                                                             <Select
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 isClearable
        //                                                                 isCreate
        //                                                                 name="shipping_method"
        //                                                                 options={list_shipping_method}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={list_shipping_method.filter(({ value, enabled }) => printer_tmp?.[row._id]?.printer?.[v.id]?.shipping_method === value && enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.printer))}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "shipping_method") }}
        //                                                                 placeholder={t("Select a shipping method ... ")}
        //                                                                 isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.printer)}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "other" ?
        //                                                             <CreatableSelect
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 name="shipping_method"
        //                                                                 options={list_shipping_method}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={{ "label": printer_tmp?.[row._id]?.printer?.[v.id]?.shipping_method, "value": printer_tmp?.[row._id]?.printer?.[v.id]?.shipping_method }}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "shipping_method") }}
        //                                                                 placeholder={t("Select a shipping method ... ")}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                 </div>
        //                                                 <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
        //                                                     <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
        //                                                         <span className="required">{t("Color")}</span>
        //                                                     </label>
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "flashship" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "mangoteeprints" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "gearment" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "hmfulfill" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "onospod" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "a2kecom" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "printeeshub" ?
        //                                                             <Select
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 isClearable
        //                                                                 name="color"
        //                                                                 options={list_color}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={list_color.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.color === value)}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "color") }}
        //                                                                 placeholder={t("Select a color ... ")}
        //                                                                 isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.type)}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "other" ?
        //                                                             <CreatableSelect
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 name="color"
        //                                                                 options={list_color}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={{ "label": printer_tmp?.[row._id]?.printer?.[v.id]?.color, "value": printer_tmp?.[row._id]?.printer?.[v.id]?.color }}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "color") }}
        //                                                                 placeholder={t("Select a color ... ")}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                 </div>
        //                                                 <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
        //                                                     <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
        //                                                         <span className="required">{t("Size")}</span>
        //                                                     </label>
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "flashship" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "mangoteeprints" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "gearment" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "hmfulfill" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "onospod" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "a2kecom" || printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "printeeshub" ?
        //                                                             <Select
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 isClearable
        //                                                                 name="size"
        //                                                                 options={list_size}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={list_size.filter(({ value }) => printer_tmp?.[row._id]?.printer?.[v.id]?.size === value)}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "size") }}
        //                                                                 placeholder={t("Select a size ... ")}
        //                                                                 isOptionDisabled={(option) => !option.enabled?.includes(printer_tmp?.[row._id]?.printer?.[v.id]?.type)}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                     {
        //                                                         printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "other" ?
        //                                                             <CreatableSelect
        //                                                                 isDisabled={row?.order_status === "worked"}
        //                                                                 name="size"
        //                                                                 options={list_size}
        //                                                                 className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-3 al-filter-table"
        //                                                                 classNamePrefix="select"
        //                                                                 value={{ "label": printer_tmp?.[row._id]?.printer?.[v.id]?.size, "value": printer_tmp?.[row._id]?.printer?.[v.id]?.size }}
        //                                                                 onChange={(e) => { onChange(e, row, formatExtraData, v, "size") }}
        //                                                                 placeholder={t("Select a size ... ")}
        //                                                             />
        //                                                             : ""
        //                                                     }
        //                                                 </div>
        //                                                 <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
        //                                                     <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
        //                                                         <span className="">{t("Basecost")}</span>
        //                                                     </label>
        //                                                     <div className="input-group">
        //                                                         <input type="number" className="form-control mw-70px al-input-basecost-order-cus" value={printer_tmp?.[row._id]?.printer?.[v.id]?.base_cost} placeholder="" name="base_cost" onChange={(e) => { onChange(e, row, formatExtraData, v, "base_cost") }} onKeyPress={(e) => { onKeyPress(e) }} disabled={row?.order_status === "worked"} />
        //                                                         <span className="input-group-text al-input-group-basecost-order-cus">$</span>
        //                                                     </div>
        //                                                 </div>
        //                                             </div>
        //                                         </Fragment>
        //                                         : ""
        //                                 }
        //                                 {
        //                                     row?.order_status !== "worked" ?
        //                                         <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
        //                                             <button type="submit" id="kt_modal_users_search_submit" className="btn btn-primary" onClick={() => { onClickSavePrintPartner(row, formatExtraData) }}  >{t("Save")}</button>
        //                                         </div>
        //                                         : ""
        //                                 }
        //                             </div>
        //                             {i + 1 !== row?.line_items.length ? <hr /> : ""}
        //                         </Fragment>
        //                     );
        //                 })
        //             }
        //         </Fragment>
        //     ),
    }, {
        field: 'recipient_address',
        headerName: t("Customer"),
        editable: false,
        sort: true,
        width: 500,
        wrapText: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row }) => (
            <Fragment>
                {/* {cell?.name} <i className="ki-outline ki-eye fs-2 align-middle cursor-pointer" onClick={() => { onClickOpenModalCustomer(cell); }}></i> */}
                <strong>{cell?.name}</strong> - {cell?.phone_number}<br />
                {
                    cell?.region_code === "US" ?
                        <Fragment>{cell?.address_line1} {cell?.address_line2 ? cell?.address_line2 : ""}, {cell?.district_info?.find((v) => v?.address_level_name === "City")?.address_name ? cell?.district_info?.find((v) => v?.address_level_name === "City")?.address_name + ", " : ""} {cell?.district_info?.find((v) => v?.address_level_name === "State")?.address_name ? cell?.district_info?.find((v) => v?.address_level_name === "State")?.address_name + ", " : ""} {cell?.district_info?.find((v) => v?.address_level_name === "Country")?.address_name ? cell?.district_info?.find((v) => v?.address_level_name === "Country")?.address_name + ", " : ""}  {cell?.postal_code ? cell?.postal_code : ""}</Fragment>
                        :
                        <Fragment>{cell?.address_line1} {cell?.address_line2 ? cell?.address_line2 : ""}, {cell?.district_info?.[3]?.address_name ? cell?.district_info?.[3]?.address_name + ", " : ""} {cell?.district_info?.[2]?.address_name && cell?.district_info?.[2]?.address_level_name !== "County" ? cell?.district_info?.[2]?.address_name + ", " : ""} {cell?.district_info?.[1]?.address_name ? cell?.district_info?.[1]?.address_name + ", " : ""} {cell?.district_info?.[0]?.address_name ? cell?.district_info?.[0]?.address_name + ", " : ""} {cell?.postal_code ? cell?.postal_code : ""}</Fragment>

                }
                {cell?.delivery_preferences?.drop_off_location && cell?.delivery_preferences?.drop_off_location !== "" ? <><br /><strong>Delivery instructions: </strong>{cell?.delivery_preferences?.drop_off_location}</> : ""}
                <br />
                {/* {+row?.payment?.original_shipping_fee > 0 && +row?.payment?.shipping_fee === 0 && +row?.payment?.shipping_fee_seller_discount === +row?.payment?.original_shipping_fee ? <span className="badge badge-light-danger fs-xl">{t("Free Shipping")} - {+row?.payment?.original_shipping_fee}</span> : +row?.payment?.original_shipping_fee === 0 && +row?.payment?.shipping_fee === 0 ? "" : +row?.payment?.original_shipping_fee > +row?.payment?.shipping_fee_seller_discount && +row?.payment?.shipping_fee_seller_discount > 0 && +row?.payment?.shipping_fee === 0 ? <span className="badge badge-light-warning fs-xl">{t("Partly Fee")} - {(+row?.payment?.shipping_fee_seller_discount).toFixed(2)}</span> : +row?.payment?.shipping_fee_seller_discount === 0 && +row?.payment?.shipping_fee > 0 ? "" : +row?.payment?.shipping_fee_seller_discount === 0 ? "" : <span className="badge badge-light-warning fs-xl">{t("Partly Fee")} - {(+row?.payment?.shipping_fee_seller_discount).toFixed(2)}</span>} */}
                {+row?.payment?.shipping_fee_seller_discount === 0 ? "" : +row?.payment?.shipping_fee > 0 ? <span className="badge badge-light-danger fs-xl" data-tooltip-id="my-tooltip"
                    data-tooltip-content="May affect earn payout">{t("Seller Shipping Discount")} - {+row?.payment?.shipping_fee_seller_discount}</span> : <span className="badge badge-light-danger fs-xl" data-tooltip-id="my-tooltip"
                        data-tooltip-content="May affect earn payout">{t("Free Shipping")} - {+row?.payment?.shipping_fee_seller_discount}</span>}
                {row?.is_sample_order ? <span className="badge badge-light-danger fs-xl">({t("Sample Affiliate")})</span> : ""}
                {row?.is_replacement_order ? <span className="badge badge-light-danger fs-xl">({t("Replacement")})</span> : ""}
            </Fragment>
        ),
    }, {
        field: 'line_items',
        headerName: t("Items"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellClass: "overflow-visible",
        width: 510,
        cellRenderer: ({ value: cell, data: row, rowIndex, formatExtraData = { page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, date_type, dateStart, dateEnd } }) => (
            <Fragment>
                <div className="card">
                    <div className="card-header collapsible cursor-pointer rotate mt-2" data-bs-toggle="collapse" data-bs-target="#kt_docs_card_collapsible" aria-expanded={openIndex === row?._id} aria-controls={`collapse-${row?._id}`} onClick={() => handleToggle(row?._id)}>
                        <h3 className="card-title w-90 d-flex flex-wrap">
                            {row?.line_items.length} {t("Items")} {row?.affiliate_order ? <span className="badge badge-light-info fs-xl ms-5" data-tooltip-id="my-tooltip"
                                data-tooltip-content={`Fee: ${row?.affiliate_amount}`}>{t("From Affiliate")} - {Math.round(Math.abs(+row?.affiliate_amount) / (+row?.payment?.original_total_product_price - +row?.payment?.seller_discount) * 100).toFixed(2)}%</span> : ""}
                            <span className="d-flex flex-wrap w-100">
                                {
                                    row?.line_items.map((v, i) => {
                                        return (
                                            <Fragment key={i}>
                                                <div className="symbol symbol-50px me-2 mt-4 " style={{ verticalAlign: "top" }}>
                                                    {
                                                        v?.sku_image ?
                                                            <Link to={v?.sku_image} target="_blank">
                                                                <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: v?.sku_image }, largeImage: { src: v?.sku_image, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '1200%', height: '1200%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                            </Link>
                                                            :
                                                            <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                    }
                                                </div>
                                            </Fragment>
                                        )
                                    })
                                }
                            </span>
                        </h3>
                        <div className={cx("card-toolbar", { "rotate-180": openIndex === row?._id })}>
                            <i className="ki-duotone ki-down fs-1"></i>
                        </div>
                    </div>
                    <div id={`collapse-${row?._id}`} className={cx("collapse mt-2", { "show": openIndex === row?._id })}>
                        <div className="card-body">
                            {
                                row?.line_items.map((v, i) => {
                                    // var colorHex = findHexAndNearestHex(row?.printer?.[v.id]?.color);
                                    return (
                                        <Fragment key={i}>
                                            <div className="mb-3" style={{ minHeight: "85px" }}>
                                                <div className="symbol symbol-50px me-2 mt-4" style={{ verticalAlign: "top" }}>
                                                    {
                                                        v?.sku_image ?
                                                            <Link to={v?.sku_image} target="_blank">
                                                                <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: v?.sku_image }, largeImage: { src: v?.sku_image, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '1200%', height: '1200%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                            </Link>
                                                            :
                                                            <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                    }
                                                </div>
                                                <div className="d-inline-block">
                                                    <span className="text-gray-900 fw-bold text-hover-primary fs-6 me-5">{subStringText(v?.product_name)}</span><button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                                                        data-tooltip-content={"Copy"}
                                                        onClick={() => navigator.clipboard.writeText(v?.product_name)}
                                                    >
                                                        <i className="ki-duotone ki-copy">
                                                        </i>
                                                    </button>
                                                    {getRefLinkUrl(v?.ref_link) ? <a
                                                        href={getRefLinkUrl(v?.ref_link)}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="btn btn-link text-hover-primary px-1"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content={t("View Ref Link")}
                                                    >
                                                        <i className="ki-outline ki-exit-right-corner">
                                                        </i>
                                                    </a> : ""}
                                                    {/* <span className="text-muted fw-semibold d-block fs-5">{v?.sku_name} ({v?.sale_price} {v?.currency})</span> */}
                                                    <span className="d-block text-gray-600 fw-bold text-hover-info fs-6">{v?.sku_name} ({v?.sale_price} {v?.currency})</span>
                                                    <div className="">
                                                        {v?.seller_sku !== "" ? `Seller SKU: ${v?.seller_sku}` : ""}
                                                    </div>
                                                    {/* <span onClick={() => { onClickOpenModalProductSettings(row, formatExtraData, v); }} className="text-primary cursor-pointer d-flex align-items-center">
                                                        <i className="ki-outline ki-setting-2 fs-2 align-middle text-primary me-1"></i>
                                                        {t("Printer Setting")}
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "flashship" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/flashship_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Flashship")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "mangoteeprints" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/mangoteeprints_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Mangoteeprints")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "gearment" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/gearment_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Gearment")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "hmfulfill" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/hmfulfill_2.svg").default} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("HM Fulfill")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "lenful" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/lenful_2.svg").default} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Lenful")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "onospod" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/onospod_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("OnosPOD")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "a2kecom" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/a2kecom_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("A2KEcom")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "printeeshub" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/printeeshub_2.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printeeshub")} />
                                                                </div>
                                                                : ""
                                                        }
                                                        {
                                                            printer_tmp?.[row._id]?.printer?.[v.id]?.printer === "saigongroups" ?
                                                                <div className="mw-100 ms-5">
                                                                    <img src={require("components/assets/media/logo-print/saigongroups.png")} alt="" className="bg-white" width="50" data-tooltip-id="my-tooltip" data-tooltip-content={t("Saigongroups")} />
                                                                </div>
                                                                : ""
                                                        }
                                                    </span> */}
                                                    {/* {(row?.design?.[v.id]?.Front || row?.design?.[v.id]?.Back || row?.design?.[v.id]?.Neck || row?.design?.[v.id]?.Right || row?.design?.[v.id]?.Left || row?.design?.[v.id]?.AOP_3D) && <>
                                                        <div className="mb-3 col-md-5 w-max-content">
                                                            {(row?.design?.[v.id]?.Front || row?.design?.[v.id]?.Back || row?.design?.[v.id]?.Neck) && <>
                                                                <div className="d-flex justify-content-center mb-5 w-max-content">
                                                                    {row?.design?.[v.id]?.Front && <div className="d-flex align-items-left justify-content-center flex-column">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.Front ?
                                                                                    <Link to={row?.design?.[v.id]?.Front} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("Front")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Front) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Front), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                    {row?.design?.[v.id]?.Back && <div className="d-flex  align-items-left justify-content-center flex-column ml-5">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.Back ?
                                                                                    <Link to={row?.design?.[v.id]?.Back} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("Back")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Back) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Back), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                    {row?.design?.[v.id]?.Neck && <div className="d-flex  align-items-left justify-content-center flex-column mr-5">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.Neck ?
                                                                                    <Link to={row?.design?.[v.id]?.Neck} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("Neck")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Neck) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Neck), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                    {row?.design?.[v.id]?.Right && <div className="d-flex  align-items-left justify-content-center flex-column mr-5">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.Right ?
                                                                                    <Link to={row?.design?.[v.id]?.Right} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("Right")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Right) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Right), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                    {row?.design?.[v.id]?.Left && <div className="d-flex  align-items-left justify-content-center flex-column mr-5">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.Left ?
                                                                                    <Link to={row?.design?.[v.id]?.Left} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("Left")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Left) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Left), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                    {row?.design?.[v.id]?.AOP_3D && <div className="d-flex  align-items-left justify-content-center flex-column mr-5">
                                                                        <div className="symbol symbol-50px me-2" style={{ backgroundColor: colorHex }}>
                                                                            {
                                                                                row?.design?.[v.id]?.AOP_3D ?
                                                                                    <Link to={row?.design?.[v.id]?.AOP_3D} target="_blank" data-tooltip-id="my-tooltip" data-tooltip-content={t("AOP3D")} >
                                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.AOP_3D) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.AOP_3D), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 9999, backgroundColor: colorHex } }} />

                                                                                    </Link>
                                                                                    :
                                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                                            }
                                                                        </div>
                                                                    </div>}
                                                                </div>
                                                            </>}
                                                        </div>
                                                    </>} */}
                                                </div>
                                            </div>
                                            {i + 1 !== row?.line_items.length ? <hr /> : ""}
                                        </Fragment>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </Fragment>
        ),
    }, {
        field: 'design',
        headerName: t("Mockup / Design"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellClass: "overflow-visible",
        cellRenderer: ({ value: cell, data: row, rowIndex, formatExtraData = { page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, date_type, dateStart, dateEnd } }) => (
            <Fragment>
                {(() => {
                    const visibleLineItems = row?.line_items?.filter(
                        (v) => !row?.printer?.[v.id]?.ignore_product // chỉ lấy item không ignore
                    );
                    var printer_tmp = row?.printer ? Object.values(row?.printer)?.[0]?.printer || "" : "";

                    return visibleLineItems.map((v, i) => (
                        <Fragment key={v.id}>
                            {(row?.design?.[v.id]?.Front || row?.design?.[v.id]?.Back || row?.design?.[v.id]?.Neck || row?.design?.[v.id]?.Right || row?.design?.[v.id]?.Left || row?.design?.[v.id]?.AOP_3D) && <>
                                <div className="row pt-3" style={{ minHeight: "85px" }}>
                                    {(row?.mockup?.[v.id]?.Front || row?.mockup?.[v.id]?.Back || row?.mockup?.[v.id]?.Neck || row?.mockup?.[v.id]?.Right || row?.mockup?.[v.id]?.Left || row?.mockup?.[v.id]?.AOP_3D) && <>
                                        <div className="mb-3 col-md-5 w-max-content">
                                            {(row?.mockup?.[v.id]?.Front || row?.mockup?.[v.id]?.Back || row?.mockup?.[v.id]?.Neck) && <>
                                                <div className="d-flex justify-content-center mb-5 w-max-content">
                                                    {row?.mockup?.[v.id]?.Front && <div className="d-flex align-items-center justify-content-center flex-column">
                                                        <span className="h3">Front</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.Front ?
                                                                    <Link to={row?.mockup?.[v.id]?.Front} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.Front) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.Front), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />
                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.mockup?.[v.id]?.Back && <div className="d-flex  align-items-center justify-content-center flex-column ml-5">
                                                        <span className="h3">Back</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.Back ?
                                                                    <Link to={row?.mockup?.[v.id]?.Back} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.Back) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.Back), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.mockup?.[v.id]?.Neck && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">{printer_tmp === "anprints" ? "Front 15" : "Neck"}</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.Neck ?
                                                                    <Link to={row?.mockup?.[v.id]?.Neck} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.Neck) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.Neck), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                </div>
                                            </>}
                                            {(row?.mockup?.[v.id]?.Right || row?.mockup?.[v.id]?.Left || row?.mockup?.[v.id]?.AOP_3D) && <>
                                                <div className="d-flex justify-content-center mb-5 w-max-content">
                                                    {row?.mockup?.[v.id]?.Right && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">Right</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.Right ?
                                                                    <Link to={row?.mockup?.[v.id]?.Right} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.Right) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.Right), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.mockup?.[v.id]?.Left && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">Left</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.Left ?
                                                                    <Link to={row?.mockup?.[v.id]?.Left} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.Left) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.Left), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.mockup?.[v.id]?.AOP_3D && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">{printer_tmp === "anprints" ? "Back 15" : "AOP 3D"}</span>
                                                        <div className="symbol symbol-50px me-2">
                                                            {
                                                                row?.mockup?.[v.id]?.AOP_3D ?
                                                                    <Link to={row?.mockup?.[v.id]?.AOP_3D} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.mockup?.[v.id]?.AOP_3D) }, largeImage: { src: formatterImage(row?.mockup?.[v.id]?.AOP_3D), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                </div>
                                            </>}
                                        </div>
                                    </>}
                                    {(row?.mockup?.[v.id]?.Front || row?.mockup?.[v.id]?.Back || row?.mockup?.[v.id]?.Neck || row?.mockup?.[v.id]?.Right || row?.mockup?.[v.id]?.Left || row?.mockup?.[v.id]?.AOP_3D) && <>
                                        <div className="mb-3 col-md-1 w-max-content d-flex justify-content-center align-items-center">
                                            /
                                        </div>
                                    </>}
                                    {(row?.design?.[v.id]?.Front || row?.design?.[v.id]?.Back || row?.design?.[v.id]?.Neck || row?.design?.[v.id]?.Right || row?.design?.[v.id]?.Left || row?.design?.[v.id]?.AOP_3D) && <>
                                        <div className="mb-3 col-md-5 w-max-content">
                                            {(row?.design?.[v.id]?.Front || row?.design?.[v.id]?.Back || row?.design?.[v.id]?.Neck) && <>
                                                <div className="d-flex justify-content-center mb-5 w-max-content">
                                                    {row?.design?.[v.id]?.Front && <div className="d-flex align-items-center justify-content-center flex-column">
                                                        <span className="h3">Front</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.Front ?
                                                                    <Link to={row?.design?.[v.id]?.Front} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Front) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Front), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.design?.[v.id]?.Back && <div className="d-flex  align-items-center justify-content-center flex-column ml-5">
                                                        <span className="h3">Back</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.Back ?
                                                                    <Link to={row?.design?.[v.id]?.Back} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Back) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Back), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.design?.[v.id]?.Neck && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">{printer_tmp === "anprints" ? "Front 15" : "Neck"}</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.Neck ?
                                                                    <Link to={row?.design?.[v.id]?.Neck} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Neck) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Neck), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                </div>
                                            </>}
                                            {(row?.design?.[v.id]?.Right || row?.design?.[v.id]?.Left || row?.design?.[v.id]?.AOP_3D) && <>
                                                <div className="d-flex justify-content-center mb-5 w-max-content">
                                                    {row?.design?.[v.id]?.Right && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">Right</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.Right ?
                                                                    <Link to={row?.design?.[v.id]?.Right} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Right) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Right), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.design?.[v.id]?.Left && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">Left</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.Left ?
                                                                    <Link to={row?.design?.[v.id]?.Left} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.Left) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.Left), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                    {row?.design?.[v.id]?.AOP_3D && <div className="d-flex  align-items-center justify-content-center flex-column mr-5">
                                                        <span className="h3">{printer_tmp === "anprints" ? "Back 15" : "AOP 3D"}</span>
                                                        <div className="symbol symbol-50px me-2" style={{ border: "1px solid #cecece" }}>
                                                            {
                                                                row?.design?.[v.id]?.AOP_3D ?
                                                                    <Link to={row?.design?.[v.id]?.AOP_3D} target="_blank">
                                                                        <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: formatterImage(row?.design?.[v.id]?.AOP_3D) }, largeImage: { src: formatterImage(row?.design?.[v.id]?.AOP_3D), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                    </Link>
                                                                    :
                                                                    <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                            }
                                                        </div>
                                                    </div>}
                                                </div>
                                            </>}
                                        </div>
                                    </>}
                                    <span className="d-block text-gray-600 fw-bold text-hover-info fs-6">
                                        {listManufacturer?.find(({ value }) => value === row?.printer?.[v.id]?.manufacturer)?.label}, {listType?.find(({ value }) => value === row?.printer?.[v.id]?.type)?.label}, {listSize?.find(({ value }) => value === row?.printer?.[v.id]?.size)?.label}, {listColor?.find(({ value }) => value === row?.printer?.[v.id]?.color)?.label}
                                    </span>
                                    {/* listManufacturer, listType, listSize, listColor */}
                                </div>
                                {i + 1 !== visibleLineItems.length ? <hr /> : ""}
                            </>}
                        </Fragment>
                    ));
                })()}
                {row?.order_status !== "worked" && (
                    <div className="pt-3 w-max-content d-flex justify-content-center align-items-center">
                        <i
                            className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer float-end"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Edit Design")}
                            onClick={() => { onClickOpenModalProductSettings(row, formatExtraData); }}
                        ></i>
                    </div>
                )}
            </Fragment >
        ),
    // }, {
    //     field: 'status',
    //     headerName: t("Order Status"),
    //     editable: false,
    //     sort: true,
    //     autoHeight: true,
    //     cellRenderer: ({ value: cell, data: row, rowIndex }) => (
    //         <Fragment>
    //             <div className="d-flex flex-column">
    //                 {row?.status === "CANCELLED" ? <div><div className="" data-tooltip-id="my-tooltip"
    //                     data-tooltip-content={`${row?.cancellation_initiator}: ${row?.cancel_reason}`}>
    //                     <FormatterStatus status={cell} large={true} /></div>
    //                     <div className="" data-tooltip-id="my-tooltip"
    //                         data-tooltip-content={t("Cancelled Time")}>{formatterCreateAt(row?.cancel_time * 1000)}</div>
    //                 </div> : <span className="" ><FormatterStatus status={cell} large={true} /></span>}
    //                 {row?.status === "DELIVERED" || row?.status === "COMPLETED" ? <>
    //                     <div data-tooltip-id="my-tooltip"
    //                         data-tooltip-content={t("Total Delivery Time (from order creation)")}>
    //                         ~{((+row?.delivery_time - +row?.create_time) / 60 / 60 / 24).toFixed(2)} Days
    //                     </div>
    //                 </> : ""}
    //             </div>
    //         </Fragment>
    //     ),
    }, {
        field: 'printer',
        headerName: t("Printer"),
        editable: false,
        sort: true,
        autoHeight: true,
        hide: role === 2,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => {
            var printer_tmp = cell ? Object.values(cell)?.[0]?.printer || "" : "";
            return (
                <Fragment>
                    {
                        printer_tmp === "cotik" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/cotik.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Cotik Partner")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "flashship" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/flashship_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Flashship")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "mangoteeprints" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/mangoteeprints_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Mangoteeprints")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "gearment" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/gearment_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Gearment")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "hmfulfill" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/hmfulfill_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("HM Fulfill")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "lenful" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/lenful_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Lenful")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "onospod" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/onospod_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("OnosPOD")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "a2kecom" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/a2k.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("A2KEcom")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printeeshub" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printeeshub_3.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printeeshub")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "monkeykingprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/monkeykingprint.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Monkeykingprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "kvfulfill" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/kv_2.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("KV Fulfill")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "visiovsolutions" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/image.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("VisiovSolutions")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "saigongroups" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/saigongroups.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Saigongroups.us")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "burgerprints" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/burgerprints.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Burgerprints")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printiz" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printiz.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printiz")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printify" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printify.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printify")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "oneprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/oneprint_2.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Oneprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "opcreative" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/opcreative_2.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("OP Creative")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "menprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/menprint.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Menprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "teroprints" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/teroprints.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Teroprints")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "fprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/fprint.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Fprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printsel" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printsel.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printsel")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "tebprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/tebprint.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Tebprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "merchize" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/merchize.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Merchize")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "saigongroupsnet" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/image.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Saigongroups.net")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "pressify" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/pressify.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Pressify")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "thgfulfill" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/thgfulfill.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("THG Fulfill")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "smartfactore" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/image.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Smartfactore")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "viettelpost_1" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/viettelpost.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Viettelpost 1")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "viettelpost_2" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/viettelpost.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Viettelpost 2")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "lizyprintfull" ?
                            <div className="ms-5">
                                <img src={require("components/assets/media/logo-print/lizyprintfull.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Lizyprintfull")} width="160" height="65" />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "sellerwix" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/sellerwix.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Sellerwix")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "anprints" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/anprints.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Anprints")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "hogotopod" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/hogotopod.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Hogotopod")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "dreamship" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/dreamship.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Dreamship")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printdoors" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printdoors.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printdoors")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "merchfox" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/merchfox.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Merchfox")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "printory" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/printory.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Printory")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "treesprint" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/treesprint.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Treesprint")} />
                            </div>
                            : ""
                    }
                    {
                        printer_tmp === "bullstart" ?
                            <div className="symbol symbol-65px ms-5">
                                <img src={require("components/assets/media/logo-print/bullstart.png")} alt="" data-tooltip-id="my-tooltip" data-tooltip-content={t("Bullstart")} />
                            </div>
                            : ""
                    }
                </Fragment>
            )
        },
        // }, {
        //     field: 'quantity',
        //     headerName: t("Quantity"),
        //     editable: false,
        //     sort: true,
        //     autoHeight: true,
        //     cellRenderer: ({ value: cell, data: row, rowIndex }) => (
        //         <Fragment>
        //             {/* {row?.orderstatements?.sku_statement_transactions ? Object.values(row?.orderstatements?.sku_statement_transactions).reduce((a, b) => +a + +b.quantity, 0) : 0} */}
        //             {
        //                 row?.line_items.map((v, i) => {
        //                     return (
        //                         <Fragment key={i}>
        //                             <div className="mb-3" style={{ minHeight: "85px" }}>
        //                                 1
        //                             </div>
        //                             {i + 1 !== row?.line_items.length ? <hr /> : ""}
        //                         </Fragment>
        //                     );
        //                 })
        //             }
        //         </Fragment>
        //     ),
        // }, {
        //     field: 'payment',
        //     headerName: t("Price"),
        //     editable: false,
        //     sort: true,
        //     autoHeight: true,
        //     cellRenderer: ({ value: cell, data: row }) => cell?.total_amount || 0
    }, {
        field: 'shipping_label',
        headerName: t("Shipping Label"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row }) => (
            <Fragment>
                {cell !== "" ? cell.split(",").map((v, i) => (<Fragment key={i}>{i > 0 && <br />}<Link to={v} target="_blank">{v}</Link></Fragment>)) : ""}
            </Fragment>
        ),
    }, {
        field: 'tracking_number',
        headerName: t("Tracking Number"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex, formatExtraData = { page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, date_type, dateStart, dateEnd, isLoading, setOrdersSelected } }) => (
            <Fragment>
                {/* {
                    row?.line_items.map((v, i) => {
                        return (
                            <Fragment key={i}>
                                <div className="mb-3" style={{ minHeight: "85px" }}>
                                    {cell} <i className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer"></i>
                                </div>
                                {i + 1 !== row?.line_items.length ? <hr /> : ""}
                            </Fragment>
                        );
                    })
                } */}

                <div className="mb-3">
                    {cell}
                    {/* {
                        row?.shipping_type === "SELLER" && row?.order_status !== "worked" ?
                            <i className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer ms-2" onClick={() => { onClickOpenModalImportTrackingV2(row, formatExtraData) }} ></i>
                            : ""
                    } */}
                </div>
            </Fragment>
        ),
    }, {
        field: 'est_amount',
        headerName: t("Est. amount"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row }) =>
            <>
                {cell > 0 ? cell :
                    row?.shipping_type === "TIKTOK" ?
                        (((+row?.payment?.original_total_product_price - +row?.payment?.seller_discount) - 6 / 100 * (+row?.payment?.total_amount + +row?.payment?.platform_discount - +row?.payment?.tax)).toFixed(2)) :
                        ((+row?.payment?.original_total_product_price - +row?.payment?.seller_discount + +row?.payment?.shipping_fee) - 6 / 100 * (+row?.payment?.total_amount + +row?.payment?.platform_discount - +row?.payment?.tax)).toFixed(2)
                }

            </>
    }, {
        field: 'fulfillment_order_id',
        headerName: t("Fulfillment Order ID"),
        editable: true,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => <Fragment>{cell} <i className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer"></i></Fragment>,
    }, {
        field: '-',
        headerName: t("Revenue"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => row?.payment?.total_amount || 0,
    }, {
        field: 'base_cost',
        headerName: t("Base Cost"),
        editable: true,
        sort: true,
        autoHeight: true,
        // cellRenderer: (value: cell, data: row, rowIndex) => <Fragment>{row?.printer ? Object.values(row?.printer).reduce((a, b) => +a + +b.base_cost, 0) : 0}</Fragment>,
        cellRenderer: ({ value: cell, data: row }) => <Fragment>{cell || 0} <i className="ki-outline ki-notepad-edit fs-2 align-middle cursor-pointer"></i></Fragment>
    }, {
        field: 'design_fee',
        headerName: t("Design Fee"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => <Fragment>{cell ? Object.values(cell).reduce((a, b) => +a + +b, 0) : 0}</Fragment>,
    }, {
        field: 'net_profits',
        headerName: t("Est. Profits"),
        editable: false,
        sort: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => <>
            {row?.est_amount ? (((row?.est_amount - (row?.base_cost || 0) - (row?.design_fee ? Object.values(row?.design_fee).reduce((a, b) => +a + +b, 0) : 0)) / row?.est_amount) * 100).toFixed(2) : 0}%
        </>,
    }, {
        field: 'shops',
        headerName: t("Shop"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => (
            <Fragment>
                <div className="d-flex flex-column">
                    <span className="">{cell?.name}</span>
                    {cell?.note || cell?.member_note ? <span className="">{cell?.note} - {cell?.member_note}</span> : ""}
                </div>
            </Fragment>
        ),
    }, {
        field: 'fulfill_member',
        headerName: t("Member"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        cellRenderer: ({ value: cell, data: row, rowIndex }) => (
            <Fragment>
                <div className="d-flex flex-column">
                    <span className="">{list_staff?.find((v, i) => v?.value === row?.createdBy)?.label || ""}</span>
                    <span className="">{list_staff?.find((v, i) => v?.value === cell)?.label || ""}</span>
                </div>
            </Fragment>
        ),
    }, {
        field: 'staff_note',
        headerName: t("Staff Note"),
        editable: false,
        sort: true,
        wrapText: true,
        autoHeight: true,
        width: 250,
        cellRenderer: ({ value: cell, data: row, rowIndex, node }) => {
            const onChangeStaffNote = (e) => {
                const newValue = e.target.value;
                node.setDataValue('staff_note', newValue);
            };

            return (
                <Fragment>
                    <select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a staff note" value={cell} name="staff_note" onChange={(e) => { onChangeStaffNote(e) }} >
                        <option value="">{t("-- Select a staff note --")}</option>
                        <option value="staff_note">{t("Staff Note")}</option>
                        <option value="media">{t("Media")}</option>
                        <option value="done">{t("Done")}</option>
                        <option value="printed">{t("Printed")}</option>
                        <option value="stamped">{t("Stamped")}</option>
                    </select>
                </Fragment>
            );
        },
    }];

    const groupButton = () => {
        return (
            <Fragment>
                <div className="mb-5">
                    <button onClick={() => { onClickSendToPrinterOrdersSelected() }} type="button" className="btn btn-primary btn-sm me-2 mb-2" disabled={orders_selected.length <= 0}>
                        <i className="ki-outline ki-send fs-2"></i> {t("Send to printer")}
                    </button>
                    <button onClick={() => { onClickCancelToPrinterOrdersSelected() }} type="button" className="btn btn-danger btn-sm me-2 mb-2" disabled={orders_selected.length <= 0}>
                        <i className="ki-outline ki-cross-square fs-2"></i> {t("Cancel to printer")}
                    </button>
                    <button onClick={() => { onClickOpenModalBuyLabelOrdersSelected() }} type="button" className="btn btn-info btn-sm me-2 mb-2" disabled={orders_selected.length <= 0}>
                        <i className="ki-outline ki-handcart fs-2"></i> {t("Buy Label")}
                    </button>
                    <button onClick={() => { onClickOpenModalChangeStatusOrdersSelected() }} type="button" className="btn btn-dark btn-sm me-2 mb-2" disabled={orders_selected.length <= 0}>
                        <i className="ki-duotone ki-delivery-3">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                        </i> {t("Change Status Order")}
                    </button>
                    <button onClick={() => { onClickOpenModalExportOrders() }} type="button" className="btn btn-success btn-sm me-2 mb-2">
                        <i className="fa fa-file-excel-o fs-2"></i> {t("Export")}
                    </button>
                    <button onClick={() => { onClickOpenModalImportTracking() }} type="button" className="btn btn-warning btn-sm me-2 mb-2">
                        <i className="fa fa-file-excel-o fs-2"></i> {t("Import Tracking")}
                    </button>
                    <button onClick={() => { onClickSyncMatchDesign() }} type="button" className="btn btn-primary btn-sm me-2 mb-2">
                        <i className="fa fa-sync fs-2"></i> {t("Sync match design")}
                    </button>
                    <button onClick={() => { onClickCombinePackage() }} type="button" className="btn btn-info btn-sm me-2 mb-2" disabled={orders_selected.length < 2}>
                        <i className="fa fa-compress fs-2"></i> {t("Combine Package")}
                    </button>
                    <button onClick={() => { onClickMakeOrderComplete() }} type="button" className="btn btn-success btn-sm me-2 mb-2" disabled={orders_selected.length < 2}>
                        <i className="ki-duotone ki-delivery-3">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                        </i> {t("Make Order Complete")}
                    </button>
                    <br />
                    <SelectCustom options={list_printer} onChange={onChangeFilterPrinter} placeholder={t("Select a printer ... ")} />
                    <SelectCustom options={list_shop} onChange={onChangeFilterShopCode} placeholder={t("Select a shop code ... ")} />
                    <SelectCustom options={list_staff} onChange={onChangeFilterStaff} placeholder={t("Select a staff ... ")} />
                    {
                        !tab_order ?
                            <SelectCustom options={list_status} onChange={onChangeFilterStatus} placeholder={t("Select a status ... ")} />
                            : ""
                    }
                    <SelectCustom options={list_work_status} onChange={onChangeFilterWorkStatus} placeholder={t("Select a work status ... ")} />
                    <SelectCustom options={list_staff_note} onChange={onChangeFilterStaffNote} placeholder={t("Select a staff note ... ")} />
                    <SelectCustom options={list_order_design} onChange={onChangeFilterOrderDesign} placeholder={t("Select a order design ... ")} mode="single" />
                    <SelectCustom options={list_shipping_type} onChange={onChangeFilterShippingType} placeholder={t("Select a shipping type ... ")} mode="single" />
                    {
                        date_type === "custom" ?
                            <DateRangePicker onCallback={handleEventDate} initialSettings={{ startDate: formatterCreateAt(dateStart || Date.now(), "dmy", "Asia/Ho_Chi_Minh"), endDate: formatterCreateAt(dateEnd || Date.now(), "dmy", "Asia/Ho_Chi_Minh"), showDropdowns: true, timePicker: true, timePicker24Hour: true, timePickerSeconds: true, timePickerIncrement: 1, startDate: moment().startOf("day"), endDate: moment().hour(23).minute(59).second(59), locale: { format: 'DD/MM/YYYY HH:mm:ss' } }}>
                                <input type="text" className="form-control al-form-control-daterangepicker me-2" />
                            </DateRangePicker>
                            : ""
                    }
                    <SelectCustom options={list_date_type} onChange={onChangeDateType} placeholder={t("Select a date ... ")} mode="single" />
                </div>
            </Fragment>
        );
    }

    // const handleTableChange = (type, { page, sizePerPage, searchText, filters }) => {
    //     if (type === "search") {
    //         setPage(1);
    //         setSizePerPage(10);
    //         setSearchText(searchText);
    //     } else if (type === "filter") {
    //         var filterVal = "";
    //         if (filters.printer) {
    //             filterVal = filters.printer.filterVal;
    //         }
    //         var filterVal2 = "";
    //         if (filters.shops) {
    //             filterVal2 = filters.shops.filterVal;
    //         }
    //         var filterVal3 = "";
    //         if (filters.status) {
    //             filterVal3 = filters.status.filterVal;
    //         }
    //         var filterVal4 = "";
    //         if (filters.staff) {
    //             filterVal4 = filters.staff.filterVal;
    //         }
    //         setPage(1);
    //         setSizePerPage(10);
    //         setFilterPrinter(filterVal);
    //         setFilterShopCode(filterVal2);
    //         setFilterStatus(filterVal3);
    //         setFilterStaff(filterVal4);
    //     } else {
    //         setPage(page || 1);
    //         setSizePerPage(sizePerPage);
    //     }
    // }

    const onSelectionChanged = (data) => {
        if (data.api) {
            const ids = data.api.getSelectedRows().map((d) => d._id);
            setOrdersSelected(ids);
        }
    };

    // const removeSelect = (arr, value) => {
    //     var i = 0;
    //     while (i < arr.length) {
    //         if (arr[i] === value) {
    //             arr.splice(i, 1);
    //         } else {
    //             ++i;
    //         }
    //     }
    //     return arr;
    // }

    // const onSelect = (row, isSelect) => {
    //     var orders_selected_tmp = orders_selected;
    //     if (isSelect) {
    //         orders_selected_tmp.push(row._id);
    //     } else {
    //         orders_selected_tmp = removeSelect(orders_selected_tmp, row._id);
    //     }
    //     var new_arr = JSON.stringify(orders_selected_tmp);
    //     setOrdersSelected(JSON.parse(new_arr));
    // };

    // const onSelectAll = (isSelect, row) => {
    //     var orders_selected_tmp = orders_selected;
    //     if (isSelect) {
    //         orders_selected_tmp = row.map((v, i) => v._id);
    //     } else {
    //         orders_selected_tmp = [];
    //     }
    //     setOrdersSelected(orders_selected_tmp);
    // };

    // const getNonSelectableRows = (rows) => {
    //     return rows
    //         .filter((row) => row?.order_status === "worked")
    //         .reduce((order, row) => {
    //             order.push(row._id);
    //             return order;
    //         }, []);
    // }

    const onCellValueChanged = ({ data, colDef, newValue, oldValue }) => {
        if (newValue !== oldValue) {
            var dateStart_tmp = dateStart;
            var dateEnd_tmp = dateEnd;
            if (date_type === "") {
                dateStart_tmp = "";
                dateEnd_tmp = "";
            }
            saveEditOrder({ _id: data._id, [colDef.field]: newValue, page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type, dateStart: dateStart_tmp, dateEnd: dateEnd_tmp });
        }
    }

    // const selectRow = {
    //     mode: 'checkbox',
    //     clickToSelect: false,
    //     selected: orders_selected,
    //     onSelect: onSelect,
    //     onSelectAll: onSelectAll,
    //     // nonSelectable: getNonSelectableRows(listorders),
    //     selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
    //         <div className="d-flex">
    //             <input
    //                 type="checkbox"
    //                 ref={(input) => {
    //                     if (input) {
    //                         input.indeterminate = indeterminate;
    //                         input.checked = checked;
    //                     }
    //                 }}
    //                 onChange={onChange}
    //             />
    //             <span style={{ marginLeft: '8px' }}>({orders_selected.length})</span>
    //         </div>
    //     ),
    // };

    const sizePerPageList = [
        {
            text: '10', value: 10
        },
        {
            text: '50', value: 50
        },
        {
            text: '100', value: 100
        },
        {
            text: '150', value: 150
        },
        {
            text: '200', value: 200
        },
        {
            text: 'All', value: totalsize || 10
        }
    ];

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const onFirstDataRendered = (params) => {
        params.columnApi.autoSizeColumns(["shops", "buyer_message", "keywords", "printer", "design", "line_items"]);
    };

    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleScroll = debounce((event) => {
        const gridBody = event.target || document.querySelector('.ag-body-viewport');
        if (gridBody) {
            // if (event.top > 0) {
            setScrollTop(gridBody.scrollTop);
            // }
        }
    }, 300);

    const onModelUpdated = () => {
        const checkRenderComplete = () => {
            const gridBody = document.querySelector('.ag-body-viewport');
            if (gridBody.scrollHeight > scrollTop) {
                // console.log(scrollTop);
                gridBody.scrollTop = scrollTop;
            } else {
                requestAnimationFrame(checkRenderComplete);
            }
        };
        requestAnimationFrame(checkRenderComplete);
    };

    return (
        <Fragment>
            <div className="card al-zoom" style={{ marginTop: "-45px" }}>
                <div className="card-body pt-0 pb-0">
                    <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_all" })} to="/admin/orders" onClick={(e) => { onClick("orders_all"); }}>
                                {t("All")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_on_hold" })} to="/admin/orders?tab=orders_on_hold" onClick={(e) => { onClick("orders_on_hold"); }}>
                                {t("On Hold")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_awaiting_shipment" })} to="/admin/orders?tab=orders_awaiting_shipment" onClick={(e) => { onClick("orders_awaiting_shipment"); }}>
                                {t("Awaiting Shipment")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_awaiting_collection" })} to="/admin/orders?tab=orders_awaiting_collection" onClick={(e) => { onClick("orders_awaiting_collection"); }}>
                                {t("Awaiting Collection")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_in_transit" })} to="/admin/orders?tab=orders_in_transit" onClick={(e) => { onClick("orders_in_transit"); }}>
                                {t("In Transit")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_delivered" })} to="/admin/orders?tab=orders_delivered" onClick={(e) => { onClick("orders_delivered"); }}>
                                {t("Delivered")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_completed" })} to="/admin/orders?tab=orders_completed" onClick={(e) => { onClick("orders_completed"); }}>
                                {t("Completed")}
                            </Link>
                        </li>
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "orders_cancelled" })} to="/admin/orders?tab=orders_cancelled" onClick={(e) => { onClick("orders_cancelled"); }}>
                                {t("Cancelled")}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card al-zoom mb-5 mb-xl-10">
                <div className="card-body p-9 al-h-cus-tb-order">
                    {/* <ReactTable columns={columns} data={listorders} groupButton={groupButton} handleTableChange={handleTableChange} page={page} sizePerPage={sizePerPage} totalSize={totalSize} alClassName="table-layout-inherit w-max-content al-d-none-option-react-select al-table-order-sticky" isSelectRow={true} selectRow={selectRow} sizePerPageList={sizePerPageList} isCellEdit={true} handleBeforeSaveCell={handleBeforeSaveCell} isSearchBar={false} isSearchBarQuick={true} /> */}
                    <ReactTableDataGrid
                        tableName="order"
                        idProperty="_id"
                        columns={columns}
                        rowData={listorders}
                        gridOptions={{
                            rowHeight: 150,
                            rowClassRules: {
                                "ag-row-cus-media": params => params.data.staff_note === "media",
                                "ag-row-cus-done": params => params.data.staff_note === "done",
                                "ag-row-cus-printed": params => params.data.staff_note === "printed",
                                "ag-row-cus-stamped": params => params.data.staff_note === "stamped",
                                "ag-row-cus-cancel": params => params.data.order_status === "cancel",
                            }
                        }}
                        paginationPageSize={sizePerPage}
                        totalSize={totalSize}
                        onTableChanged={onTableChanged}
                        emptyText={t("No data!")}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChanged}
                        sizePerPageList={sizePerPageList}
                        onCellValueChanged={onCellValueChanged}
                        onFirstDataRendered={onFirstDataRendered}
                        defaultColDef={{ suppressMenu: true }}
                        groupButton={groupButton}
                        className="al-d-none-option-react-select"
                        onBodyScroll={handleScroll}
                        onModelUpdated={onModelUpdated}
                        inputSearchType="textarea"
                    />
                    {isOpenModalEditDesign ? (<Modaleditdesign openModal={onClickOpenModalEditDesign} isOpenModalEditDesign={isOpenModalEditDesign} editdesign={editdesign} />) : ("")}
                    {isOpenModalEditOrderStatus ? (<Modaleditorderstatus openModal={onClickOpenModalEditOrderStatus} isOpenModalEditOrderStatus={isOpenModalEditOrderStatus} editorderstatus={editorderstatus} />) : ("")}
                    {isOpenModalBuyLabel ? (<Modalbuylabel openModal={onClickOpenModalBuyLabel} isOpenModalBuyLabel={isOpenModalBuyLabel} buylabel={buylabel} />) : ("")}
                    {isOpenModalImportTracking ? <Modalimporttracking openModal={onClickOpenModalImportTracking} isOpenModalImportTracking={isOpenModalImportTracking} setIsOpenModalImportTrackingV2={setIsOpenModalImportTrackingV2} setImportTrackingV2={setImportTrackingV2} /> : ''}
                    {isOpenModalProductSettings ? (<Modalproductsettings openModal={onClickOpenModalProductSettings} isOpenModalProductSettings={isOpenModalProductSettings} productsettings={productsettings} />) : ("")}
                    {isOpenModalSplitOrder ? (<Modalsplitorder openModal={onClickOpenModalSplitOrder} isOpenModalSplitOrder={isOpenModalSplitOrder} splitorder={splitorder} />) : ("")}
                    {isOpenModalImportTrackingV2 ? (<Modalimporttrackingv2 openModal={onClickOpenModalImportTrackingV2} isOpenModalImportTrackingV2={isOpenModalImportTrackingV2} importtrackingv2={importtrackingv2} />) : ("")}
                    {isOpenModalCustomer ? (<Modalcustomer openModal={onClickOpenModalCustomer} isOpenModalCustomer={isOpenModalCustomer} customer={customer} />) : ("")}
                    {isOpenModalExportOrders ? (<Modalexportorders openModal={onClickOpenModalExportOrders} isOpenModalExportOrders={isOpenModalExportOrders} exportorders={exportorders} orders_selected={orders_selected} list_staff={list_staff} />) : ("")}
                    {isOpenModalUploadInvoice ? (<Modaluploadinvoice openModal={onClickOpenModalUploadInvoice} isOpenModalUploadInvoice={isOpenModalUploadInvoice} uploadinvoice={uploadinvoice} />) : ("")}
                </div>
            </div>
            <ModalChat
                isOpen={!!editMember}
                data={editMember}
                onClose={() => setEditMember(null)}
                // onSubmit={(data) =>
                //     saveEditOrderMember({
                //         ...data,
                //         page,
                //         sizePerPage,
                //         searchText,
                //         filter_printer,
                //         filter_shop_code,
                //         filter_status,
                //         filter_work_status,
                //         filter_staff_note,
                //         filter_staff,
                //         filter_order_design,
                //         filter_shipping_type,
                //         dateStart,
                //         dateEnd,
                //     }, () => setEditMember(null))
                // }
            />
            <ModalRefund
                isOpen={Boolean(orderRefund)}
                onClose={() => setOrderRefund(null)}
                order={orderRefund}
                onSubmit={() => {
                    getListOrders(page, sizePerPage, searchText, filter_printer, filter_shop_code, filter_status, filter_work_status, filter_staff_note, filter_staff, filter_order_design, filter_shipping_type);
                    setOrderRefund(null);
                }}
            />
        </Fragment>
    );
}

Listorders.propTypes = {
    formatterCreateAt: PropTypes.func.isRequired,
    getListOrders: PropTypes.func.isRequired,
    subStringText: PropTypes.func.isRequired,
    saveEditOrder: PropTypes.func.isRequired,
    sendToPrinter: PropTypes.func.isRequired,
    cancelToPrinter: PropTypes.func.isRequired,
    FormatterStatus: PropTypes.func.isRequired,
    formatterImage: PropTypes.func.isRequired,
    getShops: PropTypes.func.isRequired,
    getStaffs: PropTypes.func.isRequired,
    syncMatchDesign: PropTypes.func.isRequired,
    findHexAndNearestHex: PropTypes.func.isRequired,
    combinePackage: PropTypes.func.isRequired,
    makeOrderComplete: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    order: state.order,
    shop: state.shop,
    team: state.team,
    user: state.user
});
const mapDispatchToProps = {
    formatterCreateAt,
    getListOrders,
    subStringText,
    saveEditOrder,
    sendToPrinter,
    cancelToPrinter,
    FormatterStatus,
    formatterImage,
    saveEditOrderMember,
    getShops,
    getStaffs,
    syncMatchDesign,
    findHexAndNearestHex,
    combinePackage,
    makeOrderComplete,
}

export default connect(mapStateToProps, mapDispatchToProps)(Listorders);
